webpackJsonp([252003105885195],{

/***/ 1363:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require("react"));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react);
	    global.USAState = mod.exports;
	  }
	})(this, function (exports, _react) {
	  "use strict";
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var USAState = function USAState(props) {
	    return _react2.default.createElement("path", { d: props.dimensions, fill: props.fill, "data-name": props.state, className: props.state + " state", onClick: props.onClickState });
	  };
	  exports.default = USAState;
	});

/***/ }),

/***/ 1364:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.usaMapDimensions = mod.exports;
	  }
	})(this, function (exports) {
	  "use strict";
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  var data = {
	    AK: {
	      dimensions: "M161.1,453.7 l-0.3,85.4 1.6,1 3.1,0.2 1.5,-1.1 h2.6 l0.2,2.9 7,6.8 0.5,2.6 3.4,-1.9 0.6,-0.2 0.3,-3.1 1.5,-1.6 1.1,-0.2 1.9,-1.5 3.1,2.1 0.6,2.9 1.9,1.1 1.1,2.4 3.9,1.8 3.4,6 2.7,3.9 2.3,2.7 1.5,3.7 5,1.8 5.2,2.1 1,4.4 0.5,3.1 -1,3.4 -1.8,2.3 -1.6,-0.8 -1.5,-3.1 -2.7,-1.5 -1.8,-1.1 -0.8,0.8 1.5,2.7 0.2,3.7 -1.1,0.5 -1.9,-1.9 -2.1,-1.3 0.5,1.6 1.3,1.8 -0.8,0.8 c0,0 -0.8,-0.3 -1.3,-1 -0.5,-0.6 -2.1,-3.4 -2.1,-3.4 l-1,-2.3 c0,0 -0.3,1.3 -1,1 -0.6,-0.3 -1.3,-1.5 -1.3,-1.5 l1.8,-1.9 -1.5,-1.5 v-5 h-0.8 l-0.8,3.4 -1.1,0.5 -1,-3.7 -0.6,-3.7 -0.8,-0.5 0.3,5.7 v1.1 l-1.5,-1.3 -3.6,-6 -2.1,-0.5 -0.6,-3.7 -1.6,-2.9 -1.6,-1.1 v-2.3 l2.1,-1.3 -0.5,-0.3 -2.6,0.6 -3.4,-2.4 -2.6,-2.9 -4.8,-2.6 -4,-2.6 1.3,-3.2 v-1.6 l-1.8,1.6 -2.9,1.1 -3.7,-1.1 -5.7,-2.4 h-5.5 l-0.6,0.5 -6.5,-3.9 -2.1,-0.3 -2.7,-5.8 -3.6,0.3 -3.6,1.5 0.5,4.5 1.1,-2.9 1,0.3 -1.5,4.4 3.2,-2.7 0.6,1.6 -3.9,4.4 -1.3,-0.3 -0.5,-1.9 -1.3,-0.8 -1.3,1.1 -2.7,-1.8 -3.1,2.1 -1.8,2.1 -3.4,2.1 -4.7,-0.2 -0.5,-2.1 3.7,-0.6 v-1.3 l-2.3,-0.6 1,-2.4 2.3,-3.9 v-1.8 l0.2,-0.8 4.4,-2.3 1,1.3 h2.7 l-1.3,-2.6 -3.7,-0.3 -5,2.7 -2.4,3.4 -1.8,2.6 -1.1,2.3 -4.2,1.5 -3.1,2.6 -0.3,1.6 2.3,1 0.8,2.1 -2.7,3.2 -6.5,4.2 -7.8,4.2 -2.1,1.1 -5.3,1.1 -5.3,2.3 1.8,1.3 -1.5,1.5 -0.5,1.1 -2.7,-1 -3.2,0.2 -0.8,2.3 h-1 l0.3,-2.4 -3.6,1.3 -2.9,1 -3.4,-1.3 -2.9,1.9 h-3.2 l-2.1,1.3 -1.6,0.8 -2.1,-0.3 -2.6,-1.1 -2.3,0.6 -1,1 -1.6,-1.1 v-1.9 l3.1,-1.3 6.3,0.6 4.4,-1.6 2.1,-2.1 2.9,-0.6 1.8,-0.8 2.7,0.2 1.6,1.3 1,-0.3 2.3,-2.7 3.1,-1 3.4,-0.6 1.3,-0.3 0.6,0.5 h0.8 l1.3,-3.7 4,-1.5 1.9,-3.7 2.3,-4.5 1.6,-1.5 0.3,-2.6 -1.6,1.3 -3.4,0.6 -0.6,-2.4 -1.3,-0.3 -1,1 -0.2,2.9 -1.5,-0.2 -1.5,-5.8 -1.3,1.3 -1.1,-0.5 -0.3,-1.9 -4,0.2 -2.1,1.1 -2.6,-0.3 1.5,-1.5 0.5,-2.6 -0.6,-1.9 1.5,-1 1.3,-0.2 -0.6,-1.8 v-4.4 l-1,-1 -0.8,1.5 h-6.1 l-1.5,-1.3 -0.6,-3.9 -2.1,-3.6 v-1 l2.1,-0.8 0.2,-2.1 1.1,-1.1 -0.8,-0.5 -1.3,0.5 -1.1,-2.7 1,-5 4.5,-3.2 2.6,-1.6 1.9,-3.7 2.7,-1.3 2.6,1.1 0.3,2.4 2.4,-0.3 3.2,-2.4 1.6,0.6 1,0.6 h1.6 l2.3,-1.3 0.8,-4.4 c0,0 0.3,-2.9 1,-3.4 0.6,-0.5 1,-1 1,-1 l-1.1,-1.9 -2.6,0.8 -3.2,0.8 -1.9,-0.5 -3.6,-1.8 -5,-0.2 -3.6,-3.7 0.5,-3.9 0.6,-2.4 -2.1,-1.8 -1.9,-3.7 0.5,-0.8 6.8,-0.5 h2.1 l1,1 h0.6 l-0.2,-1.6 3.9,-0.6 2.6,0.3 1.5,1.1 -1.5,2.1 -0.5,1.5 2.7,1.6 5,1.8 1.8,-1 -2.3,-4.4 -1,-3.2 1,-0.8 -3.4,-1.9 -0.5,-1.1 0.5,-1.6 -0.8,-3.9 -2.9,-4.7 -2.4,-4.2 2.9,-1.9 h3.2 l1.8,0.6 4.2,-0.2 3.7,-3.6 1.1,-3.1 3.7,-2.4 1.6,1 2.7,-0.6 3.7,-2.1 1.1,-0.2 1,0.8 4.5,-0.2 2.7,-3.1 h1.1 l3.6,2.4 1.9,2.1 -0.5,1.1 0.6,1.1 1.6,-1.6 3.9,0.3 0.3,3.7 1.9,1.5 7.1,0.6 6.3,4.2 1.5,-1 5.2,2.6 2.1,-0.6 1.9,-0.8 4.8,1.9z m-115.1,28.9 2.1,5.3 -0.2,1 -2.9,-0.3 -1.8,-4 -1.8,-1.5 h-2.4 l-0.2,-2.6 1.8,-2.4 1.1,2.4 1.5,1.5z m-2.6,33.5 3.7,0.8 3.7,1 0.8,1 -1.6,3.7 -3.1,-0.2 -3.4,-3.6z m-20.7,-14.1 1.1,2.6 1.1,1.6 -1.1,0.8 -2.1,-3.1 v-1.9z m-13.7,73.1 3.4,-2.3 3.4,-1 2.6,0.3 0.5,1.6 1.9,0.5 1.9,-1.9 -0.3,-1.6 2.7,-0.6 2.9,2.6 -1.1,1.8 -4.4,1.1 -2.7,-0.5 -3.7,-1.1 -4.4,1.5 -1.6,0.3z m48.9,-4.5 1.6,1.9 2.1,-1.6 -1.5,-1.3z m2.9,3 1.1,-2.3 2.1,0.3 -0.8,1.9 h-2.4z m23.6,-1.9 1.5,1.8 1,-1.1 -0.8,-1.9z m8.8,-12.5 1.1,5.8 2.9,0.8 5,-2.9 4.4,-2.6 -1.6,-2.4 0.5,-2.4 -2.1,1.3 -2.9,-0.8 1.6,-1.1 1.9,0.8 3.9,-1.8 0.5,-1.5 -2.4,-0.8 0.8,-1.9 -2.7,1.9 -4.7,3.6 -4.8,2.9z m42.3,-19.8 2.4,-1.5 -1,-1.8 -1.8,1z",
	      abbreviation: "AK",
	      name: "Alaska"
	    },
	    HI: {
	      dimensions: "M233.1,519.3 l1.9,-3.6 2.3,-0.3 0.3,0.8 -2.1,3.1z m10.2,-3.7 6.1,2.6 2.1,-0.3 1.6,-3.9 -0.6,-3.4 -4.2,-0.5 -4,1.8z m30.7,10 3.7,5.5 2.4,-0.3 1.1,-0.5 1.5,1.3 3.7,-0.2 1,-1.5 -2.9,-1.8 -1.9,-3.7 -2.1,-3.6 -5.8,2.9z m20.2,8.9 1.3,-1.9 4.7,1 0.6,-0.5 6.1,0.6 -0.3,1.3 -2.6,1.5 -4.4,-0.3z m5.3,5.2 1.9,3.9 3.1,-1.1 0.3,-1.6 -1.6,-2.1 -3.7,-0.3z m7,-1.2 2.3,-2.9 4.7,2.4 4.4,1.1 4.4,2.7 v1.9 l-3.6,1.8 -4.8,1 -2.4,-1.5z m16.6,15.6 1.6,-1.3 3.4,1.6 7.6,3.6 3.4,2.1 1.6,2.4 1.9,4.4 4,2.6 -0.3,1.3 -3.9,3.2 -4.2,1.5 -1.5,-0.6 -3.1,1.8 -2.4,3.2 -2.3,2.9 -1.8,-0.2 -3.6,-2.6 -0.3,-4.5 0.6,-2.4 -1.6,-5.7 -2.1,-1.8 -0.2,-2.6 2.3,-1 2.1,-3.1 0.5,-1 -1.6,-1.8z",
	      abbreviation: "HI",
	      name: "Hawaii"
	    },
	    AL: {
	      dimensions: "M628.5,466.4 l0.6,0.2 1.3,-2.7 1.5,-4.4 2.3,0.6 3.1,6 v1 l-2.7,1.9 2.7,0.3 5.2,-2.5 -0.3,-7.6 -2.5,-1.8 -2,-2 0.4,-4 10.5,-1.5 25.7,-2.9 6.7,-0.6 5.6,0.1 -0.5,-2.2 -1.5,-0.8 -0.9,-1.1 1,-2.6 -0.4,-5.2 -1.6,-4.5 0.8,-5.1 1.7,-4.8 -0.2,-1.7 -1.8,-0.7 -0.5,-3.6 -2.7,-3.4 -2,-6.5 -1.4,-6.7 -1.8,-5 -3.8,-16 -3.5,-7.9 -0.8,-5.6 0.1,-2.2 -9,0.8 -23.4,2.2 -12.2,0.8 -0.2,6.4 0.2,16.7 -0.7,31 -0.3,14.1 2.8,18.8 1.6,14.7z",
	      abbreviation: "AL",
	      name: "Alabama"
	    },
	    AR: {
	      dimensions: "M587.3,346.1 l-6.4,-0.7 0.9,-3.1 3.1,-2.6 0.6,-2.3 -1.8,-2.9 -31.9,1.2 -23.3,0.7 -23.6,0.3 1.5,6.9 0.1,8.5 1.4,10.9 0.3,38.2 2.1,1.6 3,-1.2 2.9,1.2 0.4,10.1 25.2,-0.2 26.8,-0.8 0.9,-1.9 -0.3,-3.8 -1.7,-3.1 1.5,-1.4 -1.4,-2.2 0.7,-2.4 1.1,-5.9 2.7,-2.3 -0.8,-2.2 4,-5.6 2.5,-1.1 -0.1,-1.7 -0.5,-1.7 2.9,-5.8 2.5,-1.1 0.2,-3.3 2.1,-1.4 0.9,-4.1 -1.4,-4 4.2,-2.4 0.3,-2.1 1.2,-4.2 0.9,-3.1z",
	      abbreviation: "AR",
	      name: "Arkansas"
	    },
	    AZ: {
	      dimensions: "M135.1,389.7 l-0.3,1.5 0.5,1 18.9,10.7 12.1,7.6 14.7,8.6 16.8,10 12.3,2.4 25.4,2.7 6,-39.6 7,-53.1 4.4,-31 -24.6,-3.6 -60.7,-11 -0.2,1.1 -2.6,16.5 -2.1,3.8 -2.8,-0.2 -1.2,-2.6 -2.6,-0.4 -1.2,-1.1 -1.1,0.1 -2.1,1.7 -0.3,6.8 -0.3,1.5 -0.5,12.5 -1.5,2.4 -0.4,3.3 2.8,5 1.1,5.5 0.7,1.1 1.1,0.9 -0.4,2.4 -1.7,1.2 -3.4,1.6 -1.6,1.8 -1.6,3.6 -0.5,4.9 -3,2.9 -1.9,0.9 -0.1,5.8 -0.6,1.6 0.5,0.8 3.9,0.4 -0.9,3 -1.7,2.4 -3.7,0.4z",
	      abbreviation: "AZ",
	      name: "Arizona"
	    },
	    CA: {
	      dimensions: "M122.7,385.9 l-19.7,-2.7 -10,-1.5 -0.5,-1.8 v-9.4 l-0.3,-3.2 -2.6,-4.2 -0.8,-2.3 -3.9,-4.2 -2.9,-4.7 -2.7,-0.2 -3.2,-0.8 -0.3,-1 1.5,-0.6 -0.6,-3.2 -1.5,-2.1 -4.8,-0.8 -3.9,-2.1 -1.1,-2.3 -2.6,-4.8 -2.9,-3.1 h-2.9 l-3.9,-2.1 -4.5,-1.8 -4.2,-0.5 -2.4,-2.7 0.5,-1.9 1.8,-7.1 0.8,-1.9 v-2.4 l-1.6,-1 -0.5,-2.9 -1.5,-2.6 -3.4,-5.8 -1.3,-3.1 -1.5,-4.7 -1.6,-5.3 -3.2,-4.4 -0.5,-2.9 0.8,-3.9 h1.1 l2.1,-1.6 1.1,-3.6 -1,-2.7 -2.7,-0.5 -1.9,-2.6 -2.1,-3.7 -0.2,-8.2 0.6,-1.9 0.6,-2.3 0.5,-2.4 -5.7,-6.3 v-2.1 l0.3,-0.5 0.3,-3.2 -1.3,-4 -2.3,-4.8 -2.7,-4.5 -1.8,-3.9 1,-3.7 0.6,-5.8 1.8,-3.1 0.3,-6.5 -1.1,-3.6 -1.6,-4.2 -2.7,-4.2 0.8,-3.2 1.5,-4.2 1.8,-0.8 0.3,-1.1 3.1,-2.6 5.2,-11.8 0.2,-7.4 1.69,-4.9 38.69,11.8 25.6,6.6 -8,31.3 -8.67,33.1 12.63,19.2 42.16,62.3 17.1,26.1 -0.4,3.1 2.8,5.2 1.1,5.4 1,1.5 0.7,0.6 -0.2,1.4 -1.4,1 -3.4,1.6 -1.9,2.1 -1.7,3.9 -0.5,4.7 -2.6,2.5 -2.3,1.1 -0.1,6.2 -0.6,1.9 1,1.7 3,0.3 -0.4,1.6 -1.4,2 -3.9,0.6z m-73.9,-48.9 1.3,1.5 -0.2,1.3 -3.2,-0.1 -0.6,-1.2 -0.6,-1.5z m1.9,0 1.2,-0.6 3.6,2.1 3.1,1.2 -0.9,0.6 -4.5,-0.2 -1.6,-1.6z m20.7,19.8 1.8,2.3 0.8,1 1.5,0.6 0.6,-1.5 -1,-1.8 -2.7,-2 -1.1,0.2 v1.2z m-1.4,8.7 1.8,3.2 1.2,1.9 -1.5,0.2 -1.3,-1.2 c0,0 -0.7,-1.5 -0.7,-1.9 0,-0.4 0,-2.2 0,-2.2z",
	      abbreviation: "CA",
	      name: "California"
	    },
	    CO: {
	      dimensions: "M380.2,235.5 l-36,-3.5 -79.1,-8.6 -2.2,22.1 -7,50.4 -1.9,13.7 34,3.9 37.5,4.4 34.7,3 14.3,0.6z",
	      abbreviation: "CO",
	      name: "Colorado"
	    },
	    CT: {
	      dimensions: "M852,190.9 l3.6,-3.2 1.9,-2.1 0.8,0.6 2.7,-1.5 5.2,-1.1 7,-3.5 -0.6,-4.2 -0.8,-4.4 -1.6,-6 -4.3,1.1 -21.8,4.7 0.6,3.1 1.5,7.3 v8.3 l-0.9,2.1 1.7,2.2z",
	      abbreviation: "CT",
	      name: "Connecticut"
	    },
	    DE: {
	      dimensions: "M834.4,247.2 l-1,0.5 -3.6,-2.4 -1.8,-4.7 -1.9,-3.6 -2.3,-1 -2.1,-3.6 0.5,-2 0.5,-2.3 0.1,-1.1 -0.6,0.1 -1.7,1 -2,1.7 -0.2,0.3 1.4,4.1 2.3,5.6 3.7,16.1 5,-0.3 6,-1.1z",
	      abbreviation: "DE",
	      name: "Delaware"
	    },
	    FL: {
	      dimensions: "M750.2,445.2 l-5.2,-0.7 -0.7,0.8 1.5,4.4 -0.4,5.2 -4.1,-1 -0.2,-2.8 h-4.1 l-5.3,0.7 -32.4,1.9 -8.2,-0.3 -1.7,-1.7 -2.5,-4.2 h-5.9 l-6.6,0.5 -35.4,4.2 -0.3,2.8 1.6,1.6 2.9,2 0.3,8.4 3.3,-0.6 6,-2.1 6,-0.5 4.4,-0.6 7.6,1.8 8.1,3.9 1.6,1.5 2.9,1.1 1.6,1.9 0.3,2.7 3.2,-1.3 h3.9 l3.6,-1.9 3.7,-3.6 3.1,0.2 0.5,-1.1 -0.8,-1 0.2,-1.9 4,-0.8 h2.6 l2.9,1.5 4.2,1.5 2.4,3.7 2.7,1 1.1,3.4 3.4,1.6 1.6,2.6 1.9,0.6 5.2,1.3 1.3,3.1 3,3.7 v9.5 l-1.5,4.7 0.3,2.7 1.3,4.8 1.8,4 0.8,-0.5 1.5,-4.5 -2.6,-1 -0.3,-0.6 1.6,-0.6 4.5,1 0.2,1.6 -3.2,5.5 -2.1,2.4 3.6,3.7 2.6,3.1 2.9,5.3 2.9,3.9 2.1,5 1.8,0.3 1.6,-2.1 1.8,1.1 2.6,4 0.6,3.6 3.1,4.4 0.8,-1.3 3.9,0.3 3.6,2.3 3.4,5.2 0.8,3.4 0.3,2.9 1.1,1 1.3,0.5 2.4,-1 1.5,-1.6 3.9,-0.2 3.1,-1.5 2.7,-3.2 -0.5,-1.9 -0.3,-2.4 0.6,-1.9 -0.3,-1.9 2.4,-1.3 0.3,-3.4 -0.6,-1.8 -0.5,-12 -1.3,-7.6 -4.5,-8.2 -3.6,-5.8 -2.6,-5.3 -2.9,-2.9 -2.9,-7.4 0.7,-1.4 1.1,-1.3 -1.6,-2.9 -4,-3.7 -4.8,-5.5 -3.7,-6.3 -5.3,-9.4 -3.7,-9.7 -2.3,-7.3z m17.7,132.7 2.4,-0.6 1.3,-0.2 1.5,-2.3 2.3,-1.6 1.3,0.5 1.7,0.3 0.4,1.1 -3.5,1.2 -4.2,1.5 -2.3,1.2z m13.5,-5 1.2,1.1 2.7,-2.1 5.3,-4.2 3.7,-3.9 2.5,-6.6 1,-1.7 0.2,-3.4 -0.7,0.5 -1,2.8 -1.5,4.6 -3.2,5.3 -4.4,4.2 -3.4,1.9z",
	      abbreviation: "FL",
	      name: "Florida"
	    },
	    GA: {
	      dimensions: "M750.2,444.2 l-5.6,-0.7 -1.4,1.6 1.6,4.7 -0.3,3.9 -2.2,-0.6 -0.2,-3 h-5.2 l-5.3,0.7 -32.3,1.9 -7.7,-0.3 -1.4,-1.2 -2.5,-4.3 -0.8,-3.3 -1.6,-0.9 -0.5,-0.5 0.9,-2.2 -0.4,-5.5 -1.6,-4.5 0.8,-4.9 1.7,-4.8 -0.2,-2.5 -1.9,-0.7 -0.4,-3.2 -2.8,-3.5 -1.9,-6.2 -1.5,-7 -1.7,-4.8 -3.8,-16 -3.5,-8 -0.8,-5.3 0.1,-2.3 3.3,-0.3 13.6,-1.6 18.6,-2 6.3,-1.1 0.5,1.4 -2.2,0.9 -0.9,2.2 0.4,2 1.4,1.6 4.3,2.7 3.2,-0.1 3.2,4.7 0.6,1.6 2.3,2.8 0.5,1.7 4.7,1.8 3,2.2 2.3,3 2.3,1.3 2,1.8 1.4,2.7 2.1,1.9 4.1,1.8 2.7,6 1.7,5.1 2.8,0.7 2.1,1.9 2,5.7 2.9,1.6 1.7,-0.8 0.4,1.2 -3.3,6.2 0.5,2.6 -1.5,4.2 -2.3,10 0.8,6.3z",
	      abbreviation: "GA",
	      name: "Georgia"
	    },
	    IA: {
	      dimensions: "M556.8,183.6 l2.1,2.1 0.3,0.7 -2,3 0.3,4 2.6,4.1 3.1,1.6 2.4,0.3 0.9,1.8 0.2,2.4 2.5,1 0.9,1.1 0.5,1.6 3.8,3.3 0.6,1.9 -0.7,3 -1.7,3.7 -0.6,2.4 -2.1,1.6 -1.6,0.5 -5.7,1.5 -1.6,4.8 0.8,1.8 1.7,1.5 -0.2,3.5 -1.9,1.4 -0.7,1.8 v2.4 l-1.4,0.4 -1.7,1.4 -0.5,1.7 0.4,1.7 -1.3,1 -2.3,-2.7 -1.4,-2.8 -8.3,0.8 -10,0.6 -49.2,1.2 -1.6,-4.3 -0.4,-6.7 -1.4,-4.2 -0.7,-5.2 -2.2,-3.7 -1,-4.6 -2.7,-7.8 -1.1,-5.6 -1.4,-1.9 -1.3,-2.9 1.7,-3.8 1.2,-6.1 -2.7,-2.2 -0.3,-2.4 0.7,-2.4 1.8,-0.3 61.1,-0.6 21.2,-0.7z",
	      abbreviation: "IA",
	      name: "Iowa"
	    },
	    ID: {
	      dimensions: "M175.3,27.63 l-4.8,17.41 -4.5,20.86 -3.4,16.22 -0.4,9.67 1.2,4.44 3.5,2.66 -0.2,3.91 -3.9,4.4 -4.5,6.6 -0.9,2.9 -1.2,1.1 -1.8,0.8 -4.3,5.3 -0.4,3.1 -0.4,1.1 0.6,1 2.6,-0.1 1.1,2.3 -2.4,5.8 -1.2,4.2 -8.8,35.3 20.7,4.5 39.5,7.9 34.8,6.1 4.9,-29.2 3.8,-24.1 -2.7,-2.4 -0.4,-2.6 -0.8,-1.1 -2.1,1 -0.7,2.6 -3.2,0.5 -3.9,-1.6 -3.8,0.1 -2.5,0.7 -3.4,-1.5 -2.4,0.2 -2.4,2 -2,-1.1 -0.7,-4 0.7,-2.9 -2.5,-2.9 -3.3,-2.6 -2.7,-13.1 -0.1,-4.7 -0.3,-0.1 -0.2,0.4 -5.1,3.5 -1.7,-0.2 -2.9,-3.4 -0.2,-3.1 7,-17.13 -0.4,-1.94 -3.4,-1.15 -0.6,-1.18 -2.6,-3.46 -4.6,-10.23 -3.2,-1.53 -2,-4.95 1.3,-4.63 -3.2,-7.58 4.4,-21.52z",
	      abbreviation: "ID",
	      name: "Idaho"
	    },
	    IL: {
	      dimensions: "M618.7,214.3 l-0.8,-2.6 -1.3,-3.7 -1.6,-1.8 -1.5,-2.6 -0.4,-5.5 -15.9,1.8 -17.4,1 h-12.3 l0.2,2.1 2.2,0.9 1.1,1.4 0.4,1.4 3.9,3.4 0.7,2.4 -0.7,3.3 -1.7,3.7 -0.8,2.7 -2.4,1.9 -1.9,0.6 -5.2,1.3 -1.3,4.1 0.6,1.1 1.9,1.8 -0.2,4.3 -2.1,1.6 -0.5,1.3 v2.8 l-1.8,0.6 -1.4,1.2 -0.4,1.2 0.4,2 -1.6,1.3 -0.9,2.8 0.3,3.9 2.3,7 7,7.6 5.7,3.7 v4.4 l0.7,1.2 6.6,0.6 2.7,1.4 -0.7,3.5 -2.2,6.2 -0.8,3 2,3.7 6.4,5.3 4.8,0.8 2.2,5.1 2,3.4 -0.9,2.8 1.5,3.8 1.7,2.1 1.6,-0.3 1,-2.2 2.4,-1.7 2.8,-1 6.1,2.5 0.5,-0.2 v-1.1 l-1.2,-2.7 0.4,-2.8 2.4,-1.6 3.4,-1.2 -0.5,-1.3 -0.8,-2 1.2,-1.3 1,-2.7 v-4 l0.4,-4.9 2.5,-3 1.8,-3.8 2.5,-4 -0.5,-5.3 -1.8,-3.2 -0.3,-3.3 0.8,-5.3 -0.7,-7.2 -1.1,-15.8 -1.4,-15.3 -0.9,-11.7z",
	      abbreviation: "IL",
	      name: "Illinois"
	    },
	    IN: {
	      dimensions: "M622.9,216.1 l1.5,1 1.1,-0.3 2.1,-1.9 2.5,-1.8 14.3,-1.1 18.4,-1.8 1.6,15.5 4.9,42.6 -0.6,2.9 1.3,1.6 0.2,1.3 -2.3,1.6 -3.6,1.7 -3.2,0.4 -0.5,4.8 -4.7,3.6 -2.9,4 0.2,2.4 -0.5,1.4 h-3.5 l-1.4,-1.7 -5.2,3 0.2,3.1 -0.9,0.2 -0.5,-0.9 -2.4,-1.7 -3.6,1.5 -1.4,2.9 -1.2,-0.6 -1.6,-1.8 -4.4,0.5 -5.7,1 -2.5,1.3 v-2.6 l0.4,-4.7 2.3,-2.9 1.8,-3.9 2.7,-4.2 -0.5,-5.8 -1.8,-3.1 -0.3,-3.2 0.8,-5.3 -0.7,-7.1 -0.9,-12.6 -2.5,-30.1z",
	      abbreviation: "IN",
	      name: "Indiana"
	    },
	    KS: {
	      dimensions: "M485.9,259.5 l-43.8,-0.6 -40.6,-1.2 -21.7,-0.9 -4.3,64.8 24.3,1 44.7,2.1 46.3,0.6 12.6,-0.3 0.7,-35 -1.2,-11.1 -2.5,-2 -2.4,-3 -2.3,-3.6 0.6,-3 1.7,-1.4 v-2.1 l-0.8,-0.7 -2.6,-0.2 -3.5,-3.4z",
	      abbreviation: "KS",
	      name: "Kansas"
	    },
	    KY: {
	      dimensions: "M607.2,331.8 l12.6,-0.7 0.1,-4.1 h4.3 l30.4,-3.2 45.1,-4.3 5.6,-3.6 3.9,-2.1 0.1,-1.9 6,-7.8 4.1,-3.6 2.1,-2.4 -3.3,-2 -2.5,-2.7 -3,-3.8 -0.5,-2.2 -2.6,-1.4 -0.9,-1.9 -0.2,-6.1 -2.6,-2 -1.9,-1.1 -0.5,-2.3 -1.3,0.2 -2,1.2 -2.5,2.7 -1.9,-1.7 -2.5,-0.5 -2.4,1.4 h-2.3 l-1.8,-2 -5.6,-0.1 -1.8,-4.5 -2.9,-1.5 -2.1,0.8 -4.2,0.2 -0.5,2.1 1.2,1.5 0.3,2.1 -2.8,2 -3.8,1.8 -2.6,0.4 -0.5,4.5 -4.9,3.6 -2.6,3.7 0.2,2.2 -0.9,2.3 -4.5,-0.1 -1.3,-1.3 -3.9,2.2 0.2,3.3 -2.4,0.6 -0.8,-1.4 -1.7,-1.2 -2.7,1.1 -1.8,3.5 -2.2,-1 -1.4,-1.6 -3.7,0.4 -5.6,1 -2.8,1.3 -1.2,3.4 -1,1 1.5,3.7 -4.2,1.4 -1.9,1.4 -0.4,2.2 1.2,2.4 v2.2 l-1.6,0.4 -6.1,-2.5 -2.3,0.9 -2,1.4 -0.8,1.8 1.7,2.4 -0.9,1.8 -0.1,3.3 -2.4,1.3 -2.1,1.7z",
	      abbreviation: "KY",
	      name: "Kentucky"
	    },
	    LA: {
	      dimensions: "M526.9,485.9 l8.1,-0.3 10.3,3.6 6.5,1.1 3.7,-1.5 3.2,1.1 3.2,1 0.8,-2.1 -3.2,-1.1 -2.6,0.5 -2.7,-1.6 0.8,-1.5 3.1,-1 1.8,1.5 1.8,-1 3.2,0.6 1.5,2.4 0.3,2.3 4.5,0.3 1.8,1.8 -0.8,1.6 -1.3,0.8 1.6,1.6 8.4,3.6 3.6,-1.3 1,-2.4 2.6,-0.6 1.8,-1.5 1.3,1 0.8,2.9 -2.3,0.8 0.6,0.6 3.4,-1.3 2.3,-3.4 0.8,-0.5 -2.1,-0.3 0.8,-1.6 -0.2,-1.5 2.1,-0.5 1.1,-1.3 0.6,0.8 0.6,3.1 4.2,0.6 4,1.9 1,1.5 h2.9 l1.1,1 2.3,-3.1 v-1.5 h-1.3 l-3.4,-2.7 -5.8,-0.8 -3.2,-2.3 1.1,-2.7 2.3,0.3 0.2,-0.6 -1.8,-1 v-0.5 h3.2 l1.8,-3.1 -1.3,-1.9 -0.3,-2.7 -1.5,0.2 -1.9,2.1 -0.6,2.6 -3.1,-0.6 -1,-1.8 1.8,-1.9 1.9,-1.7 -2.2,-6.5 -3.4,-3.4 1,-7.3 -0.2,-0.5 -1.3,0.2 -33.1,1.4 -0.8,-2.4 0.8,-8.5 8.6,-14.8 -0.9,-2.6 1.4,-0.4 0.4,-2 -2.2,-2 0.1,-1.9 -2,-4.5 -0.4,-5.1 0.1,-0.7 -26.4,0.8 -25.2,0.1 0.4,9.7 0.7,9.5 0.5,3.7 2.6,4.5 0.9,4.4 4.3,6 0.3,3.1 0.6,0.8 -0.7,8.3 -2.8,4.6 1.2,2.4 -0.5,2.6 -0.8,7.3 -1.3,3 0.2,3.7z",
	      abbreviation: "LA",
	      name: "Luisiana"
	    },
	    MA: {
	      dimensions: "M887.5,172.5 l-0.5,-2.3 0.8,-1.5 2.9,-1.5 0.8,3.1 -0.5,1.8 -2.4,1.5 v1 l1.9,-1.5 3.9,-4.5 3.9,-1.9 4.2,-1.5 -0.3,-2.4 -1,-2.9 -1.9,-2.4 -1.8,-0.8 -2.1,0.2 -0.5,0.5 1,1.3 1.5,-0.8 2.1,1.6 0.8,2.7 -1.8,1.8 -2.3,1 -3.6,-0.5 -3.9,-6 -2.3,-2.6 h-1.8 l-1.1,0.8 -1.9,-2.6 0.3,-1.5 2.4,-5.2 -2.9,-4.4 -3.7,1.8 -1.8,2.9 -18.3,4.7 -13.8,2.5 -0.6,10.6 0.7,4.9 22,-4.8 11.2,-2.8 2,1.6 3.4,4.3 2.9,4.7z m12.5,1.4 2.2,-0.7 0.5,-1.7 1,0.1 1,2.3 -1.3,0.5 -3.9,0.1z m-9.4,0.8 2.3,-2.6 h1.6 l1.8,1.5 -2.4,1 -2.2,1z",
	      abbreviation: "MA",
	      name: "Massachusetts"
	    },
	    MD: {
	      dimensions: "M834.8,264.1 l1.7,-3.8 0.5,-4.8 -6.3,1.1 -5.8,0.3 -3.8,-16.8 -2.3,-5.5 -1.5,-4.6 -22.2,4.3 -37.6,7.6 2,10.4 4.8,-4.9 2.5,-0.7 1.4,-1.5 1.8,-2.7 1.6,0.7 2.6,-0.2 2.6,-2.1 2,-1.5 2.1,-0.6 1.5,1.1 2.7,1.4 1.9,1.8 1.3,1.4 4.8,1.6 -0.6,2.9 5.8,2.1 2.1,-2.6 3.7,2.5 -2.1,3.3 -0.7,3.3 -1.8,2.6 v2.1 l0.3,0.8 2,1.3 3.4,1.1 4.3,-0.1 3.1,1 2.1,0.3 1,-2.1 -1.5,-2.1 v-1.8 l-2.4,-2.1 -2.1,-5.5 1.3,-5.3 -0.2,-2.1 -1.3,-1.3 c0,0 1.5,-1.6 1.5,-2.3 0,-0.6 0.5,-2.1 0.5,-2.1 l1.9,-1.3 1.9,-1.6 0.5,1 -1.5,1.6 -1.3,3.7 0.3,1.1 1.8,0.3 0.5,5.5 -2.1,1 0.3,3.6 0.5,-0.2 1.1,-1.9 1.6,1.8 -1.6,1.3 -0.3,3.4 2.6,3.4 3.9,0.5 1.6,-0.8 3.2,4.2 1,0.4z m-14.5,0.2 1.1,2.5 0.2,1.8 1.1,1.9 c0,0 0.9,-0.9 0.9,-1.2 0,-0.3 -0.7,-3.1 -0.7,-3.1 l-0.7,-2.3z",
	      abbreviation: "MD",
	      name: "Maryland"
	    },
	    ME: {
	      dimensions: "M865.8,91.9 l1.5,0.4 v-2.6 l0.8,-5.5 2.6,-4.7 1.5,-4 -1.9,-2.4 v-6 l0.8,-1 0.8,-2.7 -0.2,-1.5 -0.2,-4.8 1.8,-4.8 2.9,-8.9 2.1,-4.2 h1.3 l1.3,0.2 v1.1 l1.3,2.3 2.7,0.6 0.8,-0.8 v-1 l4,-2.9 1.8,-1.8 1.5,0.2 6,2.4 1.9,1 9.1,29.9 h6 l0.8,1.9 0.2,4.8 2.9,2.3 h0.8 l0.2,-0.5 -0.5,-1.1 2.8,-0.5 1.9,2.1 2.3,3.7 v1.9 l-2.1,4.7 -1.9,0.6 -3.4,3.1 -4.8,5.5 c0,0 -0.6,0 -1.3,0 -0.6,0 -1,-2.1 -1,-2.1 l-1.8,0.2 -1,1.5 -2.4,1.5 -1,1.5 1.6,1.5 -0.5,0.6 -0.5,2.7 -1.9,-0.2 v-1.6 l-0.3,-1.3 -1.5,0.3 -1.8,-3.2 -2.1,1.3 1.3,1.5 0.3,1.1 -0.8,1.3 0.3,3.1 0.2,1.6 -1.6,2.6 -2.9,0.5 -0.3,2.9 -5.3,3.1 -1.3,0.5 -1.6,-1.5 -3.1,3.6 1,3.2 -1.5,1.3 -0.2,4.4 -1.1,6.3 -2.2,-0.9 -0.5,-3.1 -4,-1.1 -0.2,-2.5 -11.7,-37.43z m36.5,15.6 1.5,-1.5 1.4,1.1 0.6,2.4 -1.7,0.9z m6.7,-5.9 1.8,1.9 c0,0 1.3,0.1 1.3,-0.2 0,-0.3 0.2,-2 0.2,-2 l0.9,-0.8 -0.8,-1.8 -2,0.7z",
	      abbreviation: "ME",
	      name: "Maine"
	    },
	    MI: {
	      dimensions: "M644.5,211 l19.1,-1.9 0.2,1.1 9.9,-1.5 12,-1.7 0.1,-0.6 0.2,-1.5 2.1,-3.7 2,-1.7 -0.2,-5.1 1.6,-1.6 1.1,-0.3 0.2,-3.6 1.5,-3 1.1,0.6 0.2,0.6 0.8,0.2 1.9,-1 -0.4,-9.1 -3.2,-8.2 -2.3,-9.1 -2.4,-3.2 -2.6,-1.8 -1.6,1.1 -3.9,1.8 -1.9,5 -2.7,3.7 -1.1,0.6 -1.5,-0.6 c0,0 -2.6,-1.5 -2.4,-2.1 0.2,-0.6 0.5,-5 0.5,-5 l3.4,-1.3 0.8,-3.4 0.6,-2.6 2.4,-1.6 -0.3,-10 -1.6,-2.3 -1.3,-0.8 -0.8,-2.1 0.8,-0.8 1.6,0.3 0.2,-1.6 -2.6,-2.2 -1.3,-2.6 h-2.6 l-4.5,-1.5 -5.5,-3.4 h-2.7 l-0.6,0.6 -1,-0.5 -3.1,-2.3 -2.9,1.8 -2.9,2.3 0.3,3.6 1,0.3 2.1,0.5 0.5,0.8 -2.6,0.8 -2.6,0.3 -1.5,1.8 -0.3,2.1 0.3,1.6 0.3,5.5 -3.6,2.1 -0.6,-0.2 v-4.2 l1.3,-2.4 0.6,-2.4 -0.8,-0.8 -1.9,0.8 -1,4.2 -2.7,1.1 -1.8,1.9 -0.2,1 0.6,0.8 -0.6,2.6 -2.3,0.5 v1.1 l0.8,2.4 -1.1,6.1 -1.6,4 0.6,4.7 0.5,1.1 -0.8,2.4 -0.3,0.8 -0.3,2.7 3.6,6 2.9,6.5 1.5,4.8 -0.8,4.7 -1,6 -2.4,5.2 -0.3,2.7 -3.2,3.1z m-33.3,-72.4 -1.3,-1.1 -1.8,-10.4 -3.7,-1.3 -1.7,-2.3 -12.6,-2.8 -2.8,-1.1 -8.1,-2.2 -7.8,-1 -3.9,-5.3 0.7,-0.5 2.7,-0.8 3.6,-2.3 v-1 l0.6,-0.6 6,-1 2.4,-1.9 4.4,-2.1 0.2,-1.3 1.9,-2.9 1.8,-0.8 1.3,-1.8 2.3,-2.3 4.4,-2.4 4.7,-0.5 1.1,1.1 -0.3,1 -3.7,1 -1.5,3.1 -2.3,0.8 -0.5,2.4 -2.4,3.2 -0.3,2.6 0.8,0.5 1,-1.1 3.6,-2.9 1.3,1.3 h2.3 l3.2,1 1.5,1.1 1.5,3.1 2.7,2.7 3.9,-0.2 1.5,-1 1.6,1.3 1.6,0.5 1.3,-0.8 h1.1 l1.6,-1 4,-3.6 3.4,-1.1 6.6,-0.3 4.5,-1.9 2.6,-1.3 1.5,0.2 v5.7 l0.5,0.3 2.9,0.8 1.9,-0.5 6.1,-1.6 1.1,-1.1 1.5,0.5 v7 l3.2,3.1 1.3,0.6 1.3,1 -1.3,0.3 -0.8,-0.3 -3.7,-0.5 -2.1,0.6 -2.3,-0.2 -3.2,1.5 h-1.8 l-5.8,-1.3 -5.2,0.2 -1.9,2.6 -7,0.6 -2.4,0.8 -1.1,3.1 -1.3,1.1 -0.5,-0.2 -1.5,-1.6 -4.5,2.4 h-0.6 l-1.1,-1.6 -0.8,0.2 -1.9,4.4 -1,4 -3.2,6.9z m-29.6,-56.5 1.8,-2.1 2.2,-0.8 5.4,-3.9 2.3,-0.6 0.5,0.5 -5.1,5.1 -3.3,1.9 -2.1,0.9z m86.2,32.1 0.6,2.5 3.2,0.2 1.3,-1.2 c0,0 -0.1,-1.5 -0.4,-1.6 -0.3,-0.2 -1.6,-1.9 -1.6,-1.9 l-2.2,0.2 -1.6,0.2 -0.3,1.1z",
	      abbreviation: "MI",
	      name: "Michigan"
	    },
	    MN: {
	      dimensions: "M464.6,66.79 l-0.6,3.91 v10.27 l1.6,5.03 1.9,3.32 0.5,9.93 1.8,13.45 1.8,7.3 0.4,6.4 v5.3 l-1.6,1.8 -1.8,1.3 v1.5 l0.9,1.7 4.1,3.5 0.7,3.2 v35.9 l60.3,-0.6 21.2,-0.7 -0.5,-6 -1.8,-2.1 -7.2,-4.6 -3.6,-5.3 -3.4,-0.9 -2,-2.8 h-3.2 l-3.5,-3.8 -0.5,-7 0.1,-3.9 1.5,-3 -0.7,-2.7 -2.8,-3.1 2.2,-6.1 5.4,-4 1.2,-1.4 -0.2,-8 0.2,-3 2.6,-3 3.8,-2.9 1.3,-0.2 4.5,-5 1.8,-0.8 2.3,-3.9 2.4,-3.6 3.1,-2.6 4.8,-2 9.2,-4.1 3.9,-1.8 0.6,-2.3 -4.4,0.4 -0.7,1.1 h-0.6 l-1.8,-3.1 -8.9,0.3 -1,0.8 h-1 l-0.5,-1.3 -0.8,-1.8 -2.6,0.5 -3.2,3.2 -1.6,0.8 h-3.1 l-2.6,-1 v-2.1 l-1.3,-0.2 -0.5,0.5 -2.6,-1.3 -0.5,-2.9 -1.5,0.5 -0.5,1 -2.4,-0.5 -5.3,-2.4 -3.9,-2.6 h-2.9 l-1.3,-1 -2.3,0.6 -1.1,1.1 -0.3,1.3 h-4.8 v-2.1 l-6.3,-0.3 -0.3,-1.5 h-4.8 l-1.6,-1.6 -1.5,-6.1 -0.8,-5.5 -1.9,-0.8 -2.3,-0.5 -0.6,0.2 -0.3,8.2 -30.1,-0.03z",
	      abbreviation: "MN",
	      name: "Minnesota"
	    },
	    MO: {
	      dimensions: "M593.1,338.7 l0.5,-5.9 4.2,-3.4 1.9,-1 v-2.9 l0.7,-1.6 -1.1,-1.6 -2.4,0.3 -2.1,-2.5 -1.7,-4.5 0.9,-2.6 -2,-3.2 -1.8,-4.6 -4.6,-0.7 -6.8,-5.6 -2.2,-4.2 0.8,-3.3 2.2,-6 0.6,-3 -1.9,-1 -6.9,-0.6 -1.1,-1.9 v-4.1 l-5.3,-3.5 -7.2,-7.8 -2.3,-7.3 -0.5,-4.2 0.7,-2.4 -2.6,-3.1 -1.2,-2.4 -7.7,0.8 -10,0.6 -48.8,1.2 1.3,2.6 -0.1,2.2 2.3,3.6 3,3.9 3.1,3 2.6,0.2 1.4,1.1 v2.9 l-1.8,1.6 -0.5,2.3 2.1,3.2 2.4,3 2.6,2.1 1.3,11.6 -0.8,40 0.5,5.7 23.7,-0.2 23.3,-0.7 32.5,-1.3 2.2,3.7 -0.8,3.1 -3.1,2.5 -0.5,1.8 5.2,0.5 4.1,-1.1z",
	      abbreviation: "MO",
	      name: "Missouri"
	    },
	    MS: {
	      dimensions: "M604.3,472.5 l2.6,-4.2 1.8,0.8 6.8,-1.9 2.1,0.3 1.5,0.8 h5.2 l0.4,-1.6 -1.7,-14.8 -2.8,-19 1,-45.1 -0.2,-16.7 0.2,-6.3 -4.8,0.3 -19.6,1.6 -13,0.4 -0.2,3.2 -2.8,1.3 -2.6,5.1 0.5,1.6 0.1,2.4 -2.9,1.1 -3.5,5.1 0.8,2.3 -3,2.5 -1,5.7 -0.6,1.9 1.6,2.5 -1.5,1.4 1.5,2.8 0.3,4.2 -1.2,2.5 -0.2,0.9 0.4,5 2,4.5 -0.1,1.7 2.3,2 -0.7,3.1 -0.9,0.3 0.6,1.9 -8.6,15 -0.8,8.2 0.5,1.5 24.2,-0.7 8.2,-0.7 1.9,-0.3 0.6,1.4 -1,7.1 3.3,3.3 2.2,6.4z",
	      abbreviation: "MS",
	      name: "Mississippi"
	    },
	    MT: {
	      dimensions: "M361.1,70.77 l-5.3,57.13 -1.3,15.2 -59.1,-6.6 -49,-7.1 -1.4,11.2 -1.9,-1.7 -0.4,-2.5 -1.3,-1.9 -3.3,1.5 -0.7,2.5 -2.3,0.3 -3.8,-1.6 -4.1,0.1 -2.4,0.7 -3.2,-1.5 -3,0.2 -2.1,1.9 -0.9,-0.6 -0.7,-3.4 0.7,-3.2 -2.7,-3.2 -3.3,-2.5 -2.5,-12.6 -0.1,-5.3 -1.6,-0.8 -0.6,1 -4.5,3.2 -1.2,-0.1 -2.3,-2.8 -0.2,-2.8 7,-17.15 -0.6,-2.67 -3.5,-1.12 -0.4,-0.91 -2.7,-3.5 -4.6,-10.41 -3.2,-1.58 -1.8,-4.26 1.3,-4.63 -3.2,-7.57 4.4,-21.29 32.7,6.89 18.4,3.4 32.3,5.3 29.3,4 29.2,3.5 30.8,3.07z",
	      abbreviation: "MT",
	      name: "Montana"
	    },
	    NC: {
	      dimensions: "M786.7,357.7 l-12.7,-7.7 -3.1,-0.8 -16.6,2.1 -1.6,-3 -2.8,-2.2 -16.7,0.5 -7.4,0.9 -9.2,4.5 -6.8,2.7 -6.5,1.2 -13.4,1.4 0.1,-4.1 1.7,-1.3 2.7,-0.7 0.7,-3.8 3.9,-2.5 3.9,-1.5 4.5,-3.7 4.4,-2.3 0.7,-3.2 4.1,-3.8 0.7,1 2.5,0.2 2.4,-3.6 1.7,-0.4 2.6,0.3 1.8,-4 2.5,-2.4 0.5,-1.8 0.1,-3.5 4.4,0.1 38.5,-5.6 57.5,-12.3 2,4.8 3.6,6.5 2.4,2.4 0.6,2.3 -2.4,0.2 0.8,0.6 -0.3,4.2 -2.6,1.3 -0.6,2.1 -1.3,2.9 -3.7,1.6 -2.4,-0.3 -1.5,-0.2 -1.6,-1.3 0.3,1.3 v1 h1.9 l0.8,1.3 -1.9,6.3 h4.2 l0.6,1.6 2.3,-2.3 1.3,-0.5 -1.9,3.6 -3.1,4.8 h-1.3 l-1.1,-0.5 -2.7,0.6 -5.2,2.4 -6.5,5.3 -3.4,4.7 -1.9,6.5 -0.5,2.4 -4.7,0.5 -5.1,1.5z m49.3,-26.2 2.6,-2.5 3.2,-2.6 1.5,-0.6 0.2,-2 -0.6,-6.1 -1.5,-2.3 -0.6,-1.9 0.7,-0.2 2.7,5.5 0.4,4.4 -0.2,3.4 -3.4,1.5 -2.8,2.4 -1.1,1.2z",
	      abbreviation: "NC",
	      name: "North Carolina"
	    },
	    ND: {
	      dimensions: "M471,126.4 l-0.4,-6.2 -1.8,-7.3 -1.8,-13.61 -0.5,-9.7 -1.9,-3.18 -1.6,-5.32 v-10.41 l0.6,-3.85 -1.8,-5.54 -28.6,-0.59 -18.6,-0.6 -26.5,-1.3 -25.2,-2.16 -0.9,14.42 -4.7,50.94 56.8,3.9 56.9,1.7z",
	      abbreviation: "ND",
	      name: "North Dakota"
	    },
	    NE: {
	      dimensions: "M470.3,204.3 l-1,-2.3 -0.5,-1.6 -2.9,-1.6 -4.8,-1.5 -2.2,-1.2 -2.6,0.1 -3.7,0.4 -4.2,1.2 -6,-4.1 -2.2,-2 -10.7,0.6 -41.5,-2.4 -35.6,-2.2 -4.3,43.7 33.1,3.3 -1.4,21.1 21.7,1 40.6,1.2 43.8,0.6 h4.5 l-2.2,-3 -2.6,-3.9 0.1,-2.3 -1.4,-2.7 -1.9,-5.2 -0.4,-6.7 -1.4,-4.1 -0.5,-5 -2.3,-3.7 -1,-4.7 -2.8,-7.9 -1,-5.3z",
	      abbreviation: "NE",
	      name: "Nebraska"
	    },
	    NH: {
	      dimensions: "M881.7,141.3 l1.1,-3.2 -2.7,-1.2 -0.5,-3.1 -4.1,-1.1 -0.3,-3 -11.7,-37.48 -0.7,0.08 -0.6,1.6 -0.6,-0.5 -1,-1 -1.5,1.9 -0.2,2.29 0.5,8.41 1.9,2.8 v4.3 l-3.9,4.8 -2.4,0.9 v0.7 l1.1,1.9 v8.6 l-0.8,9.2 -0.2,4.7 1,1.4 -0.2,4.7 -0.5,1.5 1,1.1 5.1,-1.2 13.8,-3.5 1.7,-2.9 4,-1.9z",
	      abbreviation: "NH",
	      name: "New Hampshire"
	    },
	    NJ: {
	      dimensions: "M823.7,228.3 l0.1,-1.5 2.7,-1.3 1.7,-2.8 1.7,-2.4 3.3,-3.2 v-1.2 l-6.1,-4.1 -1,-2.7 -2.7,-0.3 -0.1,-0.9 -0.7,-2.2 2.2,-1.1 0.2,-2.9 -1.3,-1.3 0.2,-1.2 1.9,-3.1 v-3.1 l2.5,-3.1 5.6,2.5 6.4,1.9 2.5,1.2 0.1,1.8 -0.5,2.7 0.4,4.5 -2.1,1.9 -1.1,1 0.5,0.5 2.7,-0.3 1.1,-0.8 1.6,3.4 0.2,9.4 0.6,1.1 -1.1,5.5 -3.1,6.5 -2.7,4 -0.8,4.8 -2.1,2.4 h-0.8 l-0.3,-2.7 0.8,-1 -0.2,-1.5 -4,-0.6 -4.8,-2.3 -3.2,-2.9 -1,-2z",
	      abbreviation: "NJ",
	      name: "New Jersey"
	    },
	    NM: {
	      dimensions: "M270.2,429.4 l-16.7,-2.6 -1.2,9.6 -15.8,-2 6,-39.7 7,-53.2 4.4,-30.9 34,3.9 37.4,4.4 32,2.8 -0.3,10.8 -1.4,-0.1 -7.4,97.7 -28.4,-1.8 -38.1,-3.7 0.7,6.3z",
	      abbreviation: "NM",
	      name: "New Mexico"
	    },
	    NV: {
	      dimensions: "M123.1,173.6 l38.7,8.5 26,5.2 -10.6,53.1 -5.4,29.8 -3.3,15.5 -2.1,11.1 -2.6,16.4 -1.7,3.1 -1.6,-0.1 -1.2,-2.6 -2.8,-0.5 -1.3,-1.1 -1.8,0.1 -0.9,0.8 -1.8,1.3 -0.3,7.3 -0.3,1.5 -0.5,12.4 -1.1,1.8 -16.7,-25.5 -42.1,-62.1 -12.43,-19 8.55,-32.6 8.01,-31.3z",
	      abbreviation: "NV",
	      name: "Nevada"
	    },
	    NY: {
	      dimensions: "M843.4,200 l0.5,-2.7 -0.2,-2.4 -3,-1.5 -6.5,-2 -6,-2.6 -0.6,-0.4 -2.7,-0.3 -2,-1.5 -2.1,-5.9 -3.3,-0.5 -2.4,-2.4 -38.4,8.1 -31.6,6 -0.5,-6.5 1.6,-1.2 1.3,-1.1 1,-1.6 1.8,-1.1 1.9,-1.8 0.5,-1.6 2.1,-2.7 1.1,-1 -0.2,-1 -1.3,-3.1 -1.8,-0.2 -1.9,-6.1 2.9,-1.8 4.4,-1.5 4,-1.3 3.2,-0.5 6.3,-0.2 1.9,1.3 1.6,0.2 2.1,-1.3 2.6,-1.1 5.2,-0.5 2.1,-1.8 1.8,-3.2 1.6,-1.9 h2.1 l1.9,-1.1 0.2,-2.3 -1.5,-2.1 -0.3,-1.5 1.1,-2.1 v-1.5 h-1.8 l-1.8,-0.8 -0.8,-1.1 -0.2,-2.6 5.8,-5.5 0.6,-0.8 1.5,-2.9 2.9,-4.5 2.7,-3.7 2.1,-2.4 2.4,-1.8 3.1,-1.2 5.5,-1.3 3.2,0.2 4.5,-1.5 7.4,-2.2 0.7,4.9 2.4,6.5 0.8,5 -1,4.2 2.6,4.5 0.8,2 -0.9,3.2 3.7,1.7 2.7,10.2 v5.8 l-0.6,10.9 0.8,5.4 0.7,3.6 1.5,7.3 v8.1 l-1.1,2.3 2.1,2.7 0.5,0.9 -1.9,1.8 0.3,1.3 1.3,-0.3 1.5,-1.3 2.3,-2.6 1.1,-0.6 1.6,0.6 2.3,0.2 7.9,-3.9 2.9,-2.7 1.3,-1.5 4.2,1.6 -3.4,3.6 -3.9,2.9 -7.1,5.3 -2.6,1 -5.8,1.9 -4,1.1 -1,-0.4z",
	      abbreviation: "NY",
	      name: "New York"
	    },
	    OH: {
	      dimensions: "M663.8,211.2 l1.7,15.5 4.8,41.1 3.9,-0.2 2.3,-0.8 3.6,1.8 1.7,4.2 5.4,0.1 1.8,2 h1.7 l2.4,-1.4 3.1,0.5 1.5,1.3 1.8,-2 2.3,-1.4 2.4,-0.4 0.6,2.7 1.6,1 2.6,2 0.8,0.2 2,-0.1 1.2,-0.6 v-2.1 l1.7,-1.5 0.1,-4.8 1.1,-4.2 1.9,-1.3 1,0.7 1,1.1 0.7,0.2 0.4,-0.4 -0.9,-2.7 v-2.2 l1.1,-1.4 2.5,-3.6 1.3,-1.5 2.2,0.5 2.1,-1.5 3,-3.3 2.2,-3.7 0.2,-5.4 0.5,-5 v-4.6 l-1.2,-3.2 1.2,-1.8 1.3,-1.2 -0.6,-2.8 -4.3,-25.6 -6.2,3.7 -3.9,2.3 -3.4,3.7 -4,3.9 -3.2,0.8 -2.9,0.5 -5.5,2.6 -2.1,0.2 -3.4,-3.1 -5.2,0.6 -2.6,-1.5 -2.2,-1.3z",
	      abbreviation: "OH",
	      name: "Ohio"
	    },
	    OK: {
	      dimensions: "M411.9,334.9 l-1.8,24.3 -0.9,18 0.2,1.6 4,3.6 1.7,0.9 h0.9 l0.9,-2.1 1.5,1.9 1.6,0.1 0.3,-0.2 0.2,-1.1 2.8,1.4 -0.4,3.5 3.8,0.5 2.5,1 4.2,0.6 2.3,1.6 2.5,-1.7 3.5,0.7 2.2,3.1 1.2,0.1 v2.3 l2.1,0.7 2.5,-2.1 1.8,0.6 2.7,0.1 0.7,2.3 4.4,1.8 1.7,-0.3 1.9,-4.2 h1.3 l1.1,2.1 4.2,0.8 3.4,1.3 3,0.8 1.6,-0.7 0.7,-2.7 h4.5 l1.9,0.9 2.7,-1.9 h1.4 l0.6,1.4 h3.6 l2,-1.8 2.3,0.6 1.7,2.2 3,1.7 3.4,0.9 1.9,1.2 -0.3,-37.6 -1.4,-10.9 -0.1,-8.6 -1.5,-6.6 -0.6,-6.8 0.1,-4.3 -12.6,0.3 -46.3,-0.5 -44.7,-2.1 -41.5,-1.8 -0.4,10.7z",
	      abbreviation: "OK",
	      name: "Oklahoma"
	    },
	    OR: {
	      dimensions: "M67.44,158.9 l28.24,7.2 27.52,6.5 17,3.7 8.8,-35.1 1.2,-4.4 2.4,-5.5 -0.7,-1.3 -2.5,0.1 -1.3,-1.8 0.6,-1.5 0.4,-3.3 4.7,-5.7 1.9,-0.9 0.9,-0.8 0.7,-2.7 0.8,-1.1 3.9,-5.7 3.7,-4 0.2,-3.26 -3.4,-2.49 -1.2,-4.55 -13.1,-3.83 -15.3,-3.47 -14.8,0.37 -1.1,-1.31 -5.1,1.84 -4.5,-0.48 -2.4,-1.58 -1.3,0.54 -4.68,-0.29 -1.96,-1.43 -4.84,-1.77 -1.1,-0.07 -4.45,-1.27 -1.76,1.52 -6.26,-0.24 -5.31,-3.85 0.21,-9.28 -2.05,-3.5 -4.1,-0.6 -0.7,-2.5 -2.4,-0.5 -5.8,2.1 -2.3,6.5 -3.2,10 -3.2,6.5 -5,14.1 -6.5,13.6 -8.1,12.6 -1.9,2.9 -0.8,8.6 -1.3,6 2.71,3.5z",
	      abbreviation: "OR",
	      name: "Oregon"
	    },
	    PA: {
	      dimensions: "M736.6,192.2 l1.3,-0.5 5.7,-5.5 0.7,6.9 33.5,-6.5 36.9,-7.8 2.3,2.3 3.1,0.4 2,5.6 2.4,1.9 2.8,0.4 0.1,0.1 -2.6,3.2 v3.1 l-1.9,3.1 -0.2,1.9 1.3,1.3 -0.2,1.9 -2.4,1.1 1,3.4 0.2,1.1 2.8,0.3 0.9,2.5 5.9,3.9 v0.4 l-3.1,3 -1.5,2.2 -1.7,2.8 -2.7,1.2 -1.4,0.3 -2.1,1.3 -1.6,1.4 -22.4,4.3 -38.7,7.8 -11.3,1.4 -3.9,0.7 -5.1,-22.4 -4.3,-25.9z",
	      abbreviation: "PA",
	      name: "Pennsylvania"
	    },
	    RI: {
	      dimensions: "M873.6,175.7 l-0.8,-4.4 -1.6,-6 5.7,-1.5 1.5,1.3 3.4,4.3 2.8,4.4 -2.8,1.4 -1.3,-0.2 -1.1,1.8 -2.4,1.9 -2.8,1.1z",
	      abbreviation: "RI",
	      name: "Rhode Island"
	    },
	    SC: {
	      dimensions: "M759,413.6 l-2.1,-1 -1.9,-5.6 -2.5,-2.3 -2.5,-0.5 -1.5,-4.6 -3,-6.5 -4.2,-1.8 -1.9,-1.8 -1.2,-2.6 -2.4,-2 -2.3,-1.3 -2.2,-2.9 -3.2,-2.4 -4.4,-1.7 -0.4,-1.4 -2.3,-2.8 -0.5,-1.5 -3.8,-5.4 -3.4,0.1 -3.9,-2.5 -1.2,-1.2 -0.2,-1.4 0.6,-1.6 2.7,-1.3 -0.8,-2 6.4,-2.7 9.2,-4.5 7.1,-0.9 16.4,-0.5 2.3,1.9 1.8,3.5 4.6,-0.8 12.6,-1.5 2.7,0.8 12.5,7.4 10.1,8.3 -5.3,5.4 -2.6,6.1 -0.5,6.3 -1.6,0.8 -1.1,2.7 -2.4,0.6 -2.1,3.6 -2.7,2.7 -2.3,3.4 -1.6,0.8 -3.6,3.4 -2.9,0.2 1,3.2 -5,5.3 -2.3,1.6z",
	      abbreviation: "SC",
	      name: "South Carolina"
	    },
	    SD: {
	      dimensions: "M471,181.1 l-0.9,3.2 0.4,3 2.6,2 -1.2,5.4 -1.8,4.1 1.5,3.3 0.7,1.1 -1.3,0.1 -0.7,-1.6 -0.6,-2 -3.3,-1.8 -4.8,-1.5 -2.5,-1.3 -2.9,0.1 -3.9,0.4 -3.8,1.2 -5.3,-3.8 -2.7,-2.4 -10.9,0.8 -41.5,-2.4 -35.6,-2.2 1.5,-24.8 2.8,-34 0.4,-5 56.9,3.9 56.9,1.7 v2.7 l-1.3,1.5 -2,1.5 -0.1,2.2 1.1,2.2 4.1,3.4 0.5,2.7 v35.9z",
	      abbreviation: "SD",
	      name: "South Dakota"
	    },
	    TN: {
	      dimensions: "M670.8,359.6 l-13.1,1.2 -23.3,2.2 -37.6,2.7 -11.8,0.4 0.9,-0.6 0.9,-4.5 -1.2,-3.6 3.9,-2.3 0.4,-2.5 1.2,-4.3 3,-9.5 0.5,-5.6 0.3,-0.2 12.3,-0.2 13.6,-0.8 0.1,-3.9 3.5,-0.1 30.4,-3.3 54,-5.2 10.3,-1.5 7.6,-0.2 2.4,-1.9 1.3,0.3 -0.1,3.3 -0.4,1.6 -2.4,2.2 -1.6,3.6 -2,-0.4 -2.4,0.9 -2.2,3.3 -1.4,-0.2 -0.8,-1.2 -1.1,0.4 -4.3,4 -0.8,3.1 -4.2,2.2 -4.3,3.6 -3.8,1.5 -4.4,2.8 -0.6,3.6 -2.5,0.5 -2,1.7 -0.2,4.8z",
	      abbreviation: "TN",
	      name: "Tennessee"
	    },
	    TX: {
	      dimensions: "M282.8,425.6 l37,3.6 29.3,1.9 7.4,-97.7 54.4,2.4 -1.7,23.3 -1,18 0.2,2 4.4,4.1 2,1.1 h1.8 l0.5,-1.2 0.7,0.9 2.4,0.2 1.1,-0.6 v-0.2 l1,0.5 -0.4,3.7 4.5,0.7 2.4,0.9 4.2,0.7 2.6,1.8 2.8,-1.9 2.7,0.6 2.2,3.1 0.8,0.1 v2.1 l3.3,1.1 2.5,-2.1 1.5,0.5 2.1,0.1 0.6,2.1 5.2,2 2.3,-0.5 1.9,-4 h0.1 l1.1,1.9 4.6,0.9 3.4,1.3 3.2,1 2.4,-1.2 0.7,-2.3 h3.6 l2.1,1 3,-2 h0.4 l0.5,1.4 h4.7 l1.9,-1.8 1.3,0.4 1.7,2.1 3.3,1.9 3.4,1 2.5,1.4 2.7,2 3.1,-1.2 2.1,0.8 0.7,20 0.7,9.5 0.6,4.1 2.6,4.4 0.9,4.5 4.2,5.9 0.3,3.1 0.6,0.8 -0.7,7.7 -2.9,4.8 1.3,2.6 -0.5,2.4 -0.8,7.2 -1.3,3 0.3,4.2 -5.6,1.6 -9.9,4.5 -1,1.9 -2.6,1.9 -2.1,1.5 -1.3,0.8 -5.7,5.3 -2.7,2.1 -5.3,3.2 -5.7,2.4 -6.3,3.4 -1.8,1.5 -5.8,3.6 -3.4,0.6 -3.9,5.5 -4,0.3 -1,1.9 2.3,1.9 -1.5,5.5 -1.3,4.5 -1.1,3.9 -0.8,4.5 0.8,2.4 1.8,7 1,6.1 1.8,2.7 -1,1.5 -3.1,1.9 -5.7,-3.9 -5.5,-1.1 -1.3,0.5 -3.2,-0.6 -4.2,-3.1 -5.2,-1.1 -7.6,-3.4 -2.1,-3.9 -1.3,-6.5 -3.2,-1.9 -0.6,-2.3 0.6,-0.6 0.3,-3.4 -1.3,-0.6 -0.6,-1 1.3,-4.4 -1.6,-2.3 -3.2,-1.3 -3.4,-4.4 -3.6,-6.6 -4.2,-2.6 0.2,-1.9 -5.3,-12.3 -0.8,-4.2 -1.8,-1.9 -0.2,-1.5 -6,-5.3 -2.6,-3.1 v-1.1 l-2.6,-2.1 -6.8,-1.1 -7.4,-0.6 -3.1,-2.3 -4.5,1.8 -3.6,1.5 -2.3,3.2 -1,3.7 -4.4,6.1 -2.4,2.4 -2.6,-1 -1.8,-1.1 -1.9,-0.6 -3.9,-2.3 v-0.6 l-1.8,-1.9 -5.2,-2.1 -7.4,-7.8 -2.3,-4.7 v-8.1 l-3.2,-6.5 -0.5,-2.7 -1.6,-1 -1.1,-2.1 -5,-2.1 -1.3,-1.6 -7.1,-7.9 -1.3,-3.2 -4.7,-2.3 -1.5,-4.4 -2.6,-2.9 -1.7,-0.5z m174.4,141.7 -0.6,-7.1 -2.7,-7.2 -0.6,-7 1.5,-8.2 3.3,-6.9 3.5,-5.4 3.2,-3.6 0.6,0.2 -4.8,6.6 -4.4,6.5 -2,6.6 -0.3,5.2 0.9,6.1 2.6,7.2 0.5,5.2 0.2,1.5z",
	      abbreviation: "TX",
	      name: "Texas"
	    },
	    UT: {
	      dimensions: "M228.4,305.9 l24.6,3.6 1.9,-13.7 7,-50.5 2.3,-22 -32.2,-3.5 2.2,-13.1 1.8,-10.6 -34.7,-6.1 -12.5,-2.5 -10.6,52.9 -5.4,30 -3.3,15.4 -1.7,9.2z",
	      abbreviation: "UT",
	      name: "Utah"
	    },
	    VA: {
	      dimensions: "M834.7,265.2 l-0.2,2.8 -2.9,3.8 -0.4,4.6 0.5,3.4 -1.8,5 -2.2,1.9 -1.5,-4.6 0.4,-5.4 1.6,-4.2 0.7,-3.3 -0.1,-1.7z m-60.3,44.6 -38.6,5.6 -4.8,-0.1 -2.2,-0.3 -2.5,1.9 -7.3,0.1 -10.3,1.6 -6.7,0.6 4.1,-2.6 4.1,-2.3 v-2.1 l5.7,-7.3 4.1,-3.7 2.2,-2.5 3.6,4.3 3.8,0.9 2.7,-1 2,-1.5 2.4,1.2 4.6,-1.3 1.7,-4.4 2.4,0.7 3.2,-2.3 1.6,0.4 2.8,-3.2 0.2,-2.7 -0.8,-1.2 4.8,-10.5 1.8,-5.2 0.5,-4.7 0.7,-0.2 1.1,1.7 1.5,1.2 3.9,-0.2 1.7,-8.1 3,-0.6 0.8,-2.6 2.8,-2.2 1.1,-2.1 1.8,-4.3 0.1,-4.6 3.6,1.4 6.6,3.1 0.3,-5.2 3.4,1.2 -0.6,2.9 8.6,3.1 1.4,1.8 -0.8,3.3 -1.3,1.3 -0.5,1.7 0.5,2.4 2,1.3 3.9,1.4 2.9,1 4.9,0.9 2.2,2.1 3.2,0.4 0.9,1.2 -0.4,4.7 1.4,1.1 -0.5,1.9 1.2,0.8 -0.2,1.4 -2.7,-0.1 0.1,1.6 2.3,1.5 0.1,1.4 1.8,1.8 0.5,2.5 -2.6,1.4 1.6,1.5 5.8,-1.7 3.7,6.2z",
	      abbreviation: "VA",
	      name: "Virginia"
	    },
	    VT: {
	      dimensions: "M832.7,111.3 l2.4,6.5 0.8,5.3 -1,3.9 2.5,4.4 0.9,2.3 -0.7,2.6 3.3,1.5 2.9,10.8 v5.3 l11.5,-2.1 -1,-1.1 0.6,-1.9 0.2,-4.3 -1,-1.4 0.2,-4.7 0.8,-9.3 v-8.5 l-1.1,-1.8 v-1.6 l2.8,-1.1 3.5,-4.4 v-3.6 l-1.9,-2.7 -0.3,-5.79 -26.1,6.79z",
	      abbreviation: "VT",
	      name: "Vermont"
	    },
	    WA: {
	      dimensions: "M74.5,67.7 l-2.3,-4.3 -4.1,-0.7 -0.4,-2.4 -2.5,-0.6 -2.9,-0.5 -1.8,1 -2.3,-2.9 0.3,-2.9 2.7,-0.3 1.6,-4 -2.6,-1.1 0.2,-3.7 4.4,-0.6 -2.7,-2.7 -1.5,-7.1 0.6,-2.9 v-7.9 l-1.8,-3.2 2.3,-9.4 2.1,0.5 2.4,2.9 2.7,2.6 3.2,1.9 4.5,2.1 3.1,0.6 2.9,1.5 3.4,1 2.3,-0.2 v-2.4 l1.3,-1.1 2.1,-1.3 0.3,1.1 0.3,1.8 -2.3,0.5 -0.3,2.1 1.8,1.5 1.1,2.4 0.6,1.9 1.5,-0.2 0.2,-1.3 -1,-1.3 -0.5,-3.2 0.8,-1.8 -0.6,-1.5 v-2.6 l1.8,-3.6 -1.1,-2.6 -2.4,-4.8 0.3,-0.8 1.4,-0.8 4.4,1.5 9.7,2.7 8.6,1.9 20,5.7 23,5.7 15,3.49 -4.8,17.56 -4.5,20.83 -3.4,16.25 -0.4,9.18 v0 l-12.9,-3.72 -15.3,-3.47 -14.5,0.32 -1.1,-1.53 -5.7,2.09 -3.9,-0.42 -2.6,-1.79 -1.7,0.65 -4.15,-0.25 -1.72,-1.32 -5.16,-1.82 -1.18,-0.16 -4.8,-1.39 -1.92,1.65 -5.65,-0.25 -4.61,-3.35z m9.6,-55.4 2,-0.2 0.5,1.4 1.5,-1.6 h2.3 l0.8,1.5 -1.5,1.7 0.6,0.8 -0.7,2 -1.4,0.4 c0,0 -0.9,0.1 -0.9,-0.2 0,-0.3 1.5,-2.6 1.5,-2.6 l-1.7,-0.6 -0.3,1.5 -0.7,0.6 -1.5,-2.3z",
	      abbreviation: "WA",
	      name: "Washington"
	    },
	    WI: {
	      dimensions: "M541.4,109.9 l2.9,0.5 2.9,-0.6 7.4,-3.2 2.9,-1.9 2.1,-0.8 1.9,1.5 -1.1,1.1 -1.9,3.1 -0.6,1.9 1,0.6 1.8,-1 1.1,-0.2 2.7,0.8 0.6,1.1 1.1,0.2 0.6,-1.1 4,5.3 8.2,1.2 8.2,2.2 2.6,1.1 12.3,2.6 1.6,2.3 3.6,1.2 1.7,10.2 1.6,1.4 1.5,0.9 -1.1,2.3 -1.8,1.6 -2.1,4.7 -1.3,2.4 0.2,1.8 1.5,0.3 1.1,-1.9 1.5,-0.8 0.8,-2.3 1.9,-1.8 2.7,-4 4.2,-6.3 0.8,-0.5 0.3,1 -0.2,2.3 -2.9,6.8 -2.7,5.7 -0.5,3.2 -0.6,2.6 0.8,1.3 -0.2,2.7 -1.9,2.4 -0.5,1.8 0.6,3.6 0.6,3.4 -1.5,2.6 -0.8,2.9 -1,3.1 1.1,2.4 0.6,6.1 1.6,4.5 -0.2,3 -15.9,1.8 -17.5,1 h-12.7 l-0.7,-1.5 -2.9,-0.4 -2.6,-1.3 -2.3,-3.7 -0.3,-3.6 2,-2.9 -0.5,-1.4 -2.1,-2.2 -0.8,-3.3 -0.6,-6.8 -2.1,-2.5 -7,-4.5 -3.8,-5.4 -3.4,-1 -2.2,-2.8 h-3.2 l-2.9,-3.3 -0.5,-6.5 0.1,-3.8 1.5,-3.1 -0.8,-3.2 -2.5,-2.8 1.8,-5.4 5.2,-3.8 1.6,-1.9 -0.2,-8.1 0.2,-2.8 2.4,-2.8z",
	      abbreviation: "WI",
	      name: "Wisconsin"
	    },
	    WV: {
	      dimensions: "M758.9,254.3 l5.8,-6 2.6,-0.8 1.6,-1.5 1.5,-2.2 1.1,0.3 3.1,-0.2 4.6,-3.6 1.5,-0.5 1.3,1 2.6,1.2 3,3 -0.4,4.3 -5.4,-2.6 -4.8,-1.8 -0.1,5.9 -2.6,5.7 -2.9,2.4 -0.8,2.3 -3,0.5 -1.7,8.1 -2.8,0.2 -1.1,-1 -1.2,-2 -2.2,0.5 -0.5,5.1 -1.8,5.1 -5,11 0.9,1.4 -0.1,2 -2.2,2.5 -1.6,-0.4 -3.1,2.3 -2.8,-0.8 -1.8,4.9 -3.8,1 -2.5,-1.3 -2.5,1.9 -2.3,0.7 -3.2,-0.8 -3.8,-4.5 -3.5,-2.2 -2.5,-2.5 -2.9,-3.7 -0.5,-2.3 -2.8,-1.7 -0.6,-1.3 -0.2,-5.6 0.3,0.1 2.4,-0.2 1.8,-1 v-2.2 l1.7,-1.5 0.1,-5.2 0.9,-3.6 1.1,-0.7 0.4,0.3 1,1.1 1.7,0.5 1.1,-1.3 -1,-3.1 v-1.6 l3.1,-4.6 1.2,-1.3 2,0.5 2.6,-1.8 3.1,-3.4 2.4,-4.1 0.2,-5.6 0.5,-4.8 v-4.9 l-1.1,-3 0.9,-1.3 0.8,-0.7 4.3,19.3 4.3,-0.8 11.2,-1.3z",
	      abbreviation: "WV",
	      name: "West Virginia"
	    },
	    WY: {
	      dimensions: "M353,161.9 l-1.5,25.4 -4.4,44 -2.7,-0.3 -83.3,-9.1 -27.9,-3 2,-12 6.9,-41 3.8,-24.2 1.3,-11.2 48.2,7 59.1,6.5z",
	      abbreviation: "WY",
	      name: "Wyoming"
	    }
	  };
	  exports.default = data;
	});

/***/ }),

/***/ 1365:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2), __webpack_require__(4), __webpack_require__(1364), __webpack_require__(1363)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require("react"), require("prop-types"), require("./data/usa-map-dimensions"), require("./components/USAState"));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.propTypes, global.usaMapDimensions, global.USAState);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _react, _propTypes, _usaMapDimensions, _USAState) {
	  "use strict";
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _propTypes2 = _interopRequireDefault(_propTypes);
	
	  var _usaMapDimensions2 = _interopRequireDefault(_usaMapDimensions);
	
	  var _USAState2 = _interopRequireDefault(_USAState);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var USAMap = function (_React$Component) {
	    _inherits(USAMap, _React$Component);
	
	    function USAMap() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, USAMap);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = USAMap.__proto__ || Object.getPrototypeOf(USAMap)).call.apply(_ref, [this].concat(args))), _this), _this.clickHandler = function (stateAbbreviation) {
	        _this.props.onClick(stateAbbreviation);
	      }, _this.fillStateColor = function (state) {
	        if (_this.props.customize && _this.props.customize[state] && _this.props.customize[state].fill) {
	          return _this.props.customize[state].fill;
	        }
	
	        return _this.props.defaultFill;
	      }, _this.stateClickHandler = function (state) {
	        if (_this.props.customize && _this.props.customize[state] && _this.props.customize[state].clickHandler) {
	          return _this.props.customize[state].clickHandler;
	        }
	        return _this.clickHandler;
	      }, _this.buildPaths = function () {
	        var paths = [];
	        for (var stateKey in _usaMapDimensions2.default) {
	          var path = _react2.default.createElement(_USAState2.default, { key: stateKey, dimensions: _usaMapDimensions2.default[stateKey]["dimensions"], state: stateKey, fill: _this.fillStateColor(stateKey), onClickState: _this.stateClickHandler(stateKey) });
	          paths.push(path);
	        };
	        return paths;
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(USAMap, [{
	      key: "render",
	      value: function render() {
	        return _react2.default.createElement(
	          "svg",
	          { className: "us-state-map", xmlns: "http://www.w3.org/2000/svg", width: this.props.width, height: this.props.height, viewBox: "0 0 959 593" },
	          _react2.default.createElement(
	            "title",
	            null,
	            this.props.title
	          ),
	          _react2.default.createElement(
	            "g",
	            { className: "outlines" },
	            this.buildPaths(),
	            _react2.default.createElement(
	              "g",
	              { className: "DC state" },
	              _react2.default.createElement("path", { className: "DC1", fill: this.fillStateColor("DC1"), d: "M801.8,253.8 l-1.1-1.6 -1-0.8 1.1-1.6 2.2,1.5z" }),
	              _react2.default.createElement("circle", { className: "DC2", onClick: this.clickHandler, "data-name": "DC", fill: this.fillStateColor("DC2"), stroke: "#FFFFFF", strokeWidth: "1.5", cx: "801.3", cy: "251.8", r: "5", opacity: "1" })
	            )
	          )
	        );
	      }
	    }]);
	
	    return USAMap;
	  }(_react2.default.Component);
	
	  USAMap.propTypes = {
	    onClick: _propTypes2.default.func.isRequired,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number,
	    title: _propTypes2.default.string,
	    defaultFill: _propTypes2.default.string,
	    customize: _propTypes2.default.object
	  };
	
	  USAMap.defaultProps = {
	    onClick: function onClick() {},
	    width: 959,
	    height: 593,
	    defaultFill: "#D3D3D3",
	    title: "Blank US states map",
	    customize: {}
	  };
	
	  exports.default = USAMap;
	});

/***/ }),

/***/ 1366:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1365);

/***/ }),

/***/ 1396:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/exhibit-overall.86c3bb2e.png";

/***/ }),

/***/ 1403:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/scorecard_rankings.3dc3e1d0.png";

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("g", {
	  fill: "none",
	  fillRule: "evenodd"
	}, _react2.default.createElement("path", {
	  d: "M142.487 217.796l-38.905 48.943h392.297l-38.901-48.943z",
	  fill: "#f47920"
	}), _react2.default.createElement("path", {
	  d: "M109.73 416.526h380.004v-142.27H109.73z",
	  fill: "#fff"
	}), _react2.default.createElement("path", {
	  d: "M101.95 424.308H497.51V266.475H101.95zm15.561-15.563h364.442V282.037H117.51z",
	  fill: "#5a5e68"
	}), _react2.default.createElement("path", {
	  d: "M191.035 392.21H408.43V144.576H191.035z",
	  fill: "#fff"
	}), _react2.default.createElement("path", {
	  d: "M198.813 384.43h201.83V152.356h-201.83zm-15.559 15.562H416.21V136.795H183.254z",
	  fill: "#5a5e68"
	}), _react2.default.createElement("path", {
	  d: "M107.781 418.211h383.902v-26H107.781z",
	  fill: "#fff"
	}), _react2.default.createElement("g", {
	  fill: "#5a5e68"
	}, _react2.default.createElement("path", {
	  d: "M100 425.992h399.464V384.43H100zm15.562-15.562h368.344v-10.435H115.562zM128.545 320.258h15.562V299.51h-15.562zM155.13 320.258h15.562V299.51h-15.563zM128.545 351.383h15.562v-20.749h-15.562zM155.13 351.383h15.562v-20.749h-15.563zM428.769 320.258h15.562V299.51h-15.562zM455.353 320.258h15.562V299.51h-15.562zM428.769 351.383h15.562v-20.749h-15.562zM455.353 351.383h15.562v-20.749h-15.562zM218.355 275.517h15.562v-20.749h-15.562zM247.791 275.517h15.562v-20.749h-15.562zM277.231 275.517h15.562v-20.749h-15.562zM306.67 275.517h15.563v-20.749h-15.562zM336.11 275.517h15.563v-20.749h-15.562zM365.547 275.517h15.562v-20.749h-15.562zM218.355 313.45h15.562V292.7h-15.562zM247.791 313.45h15.562V292.7h-15.562zM277.231 313.45h15.562V292.7h-15.562zM306.67 313.45h15.563V292.7h-15.562zM336.11 313.45h15.563V292.7h-15.562zM365.547 313.45h15.562V292.7h-15.562zM218.355 201.596h15.562v-20.749h-15.562zM247.791 201.596h15.562v-20.749h-15.562zM277.231 201.596h15.562v-20.749h-15.562zM306.67 201.596h15.563v-20.749h-15.562zM336.11 201.596h15.563v-20.749h-15.562zM365.547 201.596h15.562v-20.749h-15.562zM218.355 239.529h15.562V218.78h-15.562zM247.791 239.529h15.562V218.78h-15.562zM277.231 239.529h15.562V218.78h-15.562zM306.67 239.529h15.563V218.78h-15.562zM336.11 239.529h15.563V218.78h-15.562zM365.547 239.529h15.562V218.78h-15.562z"
	})), _react2.default.createElement("path", {
	  d: "M179.726 145.222h240.013v-32.53H179.726z",
	  fill: "#fff"
	}), _react2.default.createElement("path", {
	  d: "M187.507 137.44h224.45v-16.966h-224.45zm-15.563 15.563H427.52V104.91H171.944z",
	  fill: "#5a5e68"
	}), _react2.default.createElement("path", {
	  d: "M231 384.43h137.465v-48.944H230.999z",
	  fill: "#4abcbc"
	}), _react2.default.createElement("path", {
	  d: "M339.285 125.313c0 21.841-17.71 39.551-39.555 39.551-21.842 0-39.552-17.71-39.552-39.551 0-21.846 17.71-39.556 39.552-39.556 21.845 0 39.555 17.71 39.555 39.556",
	  fill: "#fff"
	}), _react2.default.createElement("path", {
	  d: "M299.732 93.538c-17.52 0-31.775 14.255-31.775 31.775s14.255 31.77 31.775 31.77 31.774-14.251 31.774-31.77-14.255-31.775-31.774-31.775m0 79.107c-26.098 0-47.337-21.234-47.337-47.332 0-26.102 21.239-47.337 47.337-47.337s47.336 21.235 47.336 47.337c0 26.098-21.238 47.332-47.336 47.332",
	  fill: "#5a5e68"
	}), _react2.default.createElement("path", {
	  d: "M291.949 145.61h15.562v-40.594H291.95z",
	  fill: "#5a5e68"
	}), _react2.default.createElement("path", {
	  d: "M279.433 133.095h40.594v-15.563h-40.594z",
	  fill: "#5a5e68"
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 600 600"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,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";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M391.189 108l-47.12 13.184-31.86 6.347-8.788.61-7.813 4.641-4.516 5.858-9.158 7.812-13.06 16.846-11.843 19.406-1.706 7.572-4.396 6.713-13.55 10.618.61 3.176-8.057 5.616-1.585 8.909 4.392 2.445 4.886 7.202 2.196-5.737 6.716 10.13-6.106 2.2-3.541 4.632 5.01 2.325 4.637 12.449-.124 10.623-10.499 2.686-11.474 12.08-2.685 6.836-14.525 9.154-10.009.614-16.85 4.272-7.932 5.496-15.5-6.106-13.92-.241-31.13 5.492-8.787 3.05-25.268 13.185 3.416 9.884-.735 5.496 3.91.73 1.221 6.472 5.612 1.831 7.327 13.55-10.743 10.132-4.03 12.695-11.59 7.812-3.79 5.982L50 419.769l3.91 22.703 55.539-9.274 132.202-26.123 25.148-5.251 61.16-13.184 4.88 2.806 4.028 7.327 9.277-.125 5.372 6.592 3.296 11.354-1.826 1.345 8.173 9.278 6.592 2.44 9.403-1.59 4.022 5.372 28.324 9.888 28.443 8.913.366 9.643-2.196 16.48.24 7.323 8.182 5.371 9.399-6.592 13.184-1.22 14.529-9.398 7.318-1.341 8.913-5.131 15.87-12.694 20.996-14.525L550 426.968l-4.516-6.099-5.858 2.437-4.512-9.033-15.019 17.946-10.984 5.616-16.6 4.637-5.131-.245-5.492 7.692-16.85.735-.486 2.561-12.449 6.837-2.565 7.448-2.807-2.81 2.2-7.323 4.633-7.938-6.833-8.543 13.184-12.818-6.106-5.858-11.108-64.33-2.196-2.931 1.465-58.594-2.44-7.202-12.085-58.229-5.376-7.443-7.808.972 1.83-12.57-10.738-21.607-.37-13.064 3.172-8.053-3.296-7.937-.976-10.863-6.347-6.593-2.072-12.573.972-4.637-3.902-3.42.73-6.958z",
	  fill: "#4abdbc",
	  fillRule: "evenodd"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 600 600"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,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";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("g", {
	  fill: "#4abdbc",
	  fillRule: "evenodd"
	}, _react2.default.createElement("path", {
	  d: "M388.214 5l-8.228 2.058-4.497 14.404-17.88 9.663-15.32-.551-8.779-10.314-9.94-4.848-6.474.873-6.144 6.56-17.411 57.938-3.114 71.429 7.33 41.253-.988 3.606-8.886 14.248-.108 6.107 3.995 6.264.082 2.724-9.496-.864-1.26.93 2.001 7.696-13.219-2.017-8.878 6.544 26.273 82.508 23.983 84.187 14.158 11.004 1.664 8.133L334.3 430l14.19-19.64 11.614-32.166-.412-13.968 6.094-11.77 8.582-7.507 4.613-.033 6.317 7.762 2.503.247 2.496-6.198-.033-12.256 2.71-1.342 4.842 4.774 3.072-.848 4.794-3.473 1.927-9.72 3.542-5.59 8.565.667 2.117-1.836 2.784-12.107-1.516-8.487 2.232-9.218-.93-12.627 4.53-6.486 3.648-2.584 2.47.214 3.163 8 4.407 5.499 5.987.115 5.172-4.223 13.433 5.35 4.514-3.456 1.606-6.635 6.564-9.91 5.666-1.662 6.285-5.548 1.367-8.083 17.666-8.65 3.072-5.853 7.824-3.26 2.792-4.543 9.027-3.638 5.403-7.515-.05-5.869-3.319-5.128-7.66.774-.263-3.004 2.06-7.713-8.088-17.894.033 3.687-4.942 2.412-10.798 1.12-11.456-3.359-4.884-4.675-8.763-23.516-19.322-3.177-35.72-120.922zM138.8 170l-5.736 4.554-22.342 8.273-5.582 9.652-4.173 34.011 6.043 10.794-8.387 26.323 15.77 21.783-1.299 12.187-21.923 33.287-18.267 11.211 5.163 53.844L61 469.081l12.183 84.136-4.982 24.43L83.677 595l131.387-32.549 36.437-34.693 11.485-.933.014-33.134-12.239-9.262-2.819-13.733-23.988-18.635L183.33 309.61z"
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 600 600"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,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";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BaselineToggle = function BaselineToggle(_ref) {
	  var selected = _ref.selected,
	      changeHandler = _ref.changeHandler;
	  return _react2.default.createElement(
	    'div',
	    { className: 'cmwf--baseline-select-group' },
	    _react2.default.createElement(
	      'label',
	      { htmlFor: 'cmwf--baseline-select' },
	      'Values'
	    ),
	    ' ',
	    _react2.default.createElement(
	      'select',
	      {
	        id: 'cmwf--baseline-select',
	        className: 'select__small',
	        onChange: function onChange(e) {
	          return changeHandler(e.target.value === 'BASELINE');
	        },
	        defaultValue: selected ? 'BASELINE' : 'CURRENT'
	      },
	      _react2.default.createElement(
	        'option',
	        {
	          value: 'CURRENT'
	        },
	        'Current'
	      ),
	      _react2.default.createElement(
	        'option',
	        {
	          value: 'BASELINE'
	        },
	        'Baseline'
	      )
	    )
	  );
	};
	
	BaselineToggle.propTypes = {
	  selected: _propTypes2.default.bool.isRequired,
	  changeHandler: _propTypes2.default.func.isRequired
	};
	
	exports.default = BaselineToggle;
	module.exports = exports['default'];

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DimensionChartState = function DimensionChartState(_ref) {
	  var state = _ref.state,
	      value = _ref.value,
	      faded = _ref.faded,
	      selected = _ref.selected,
	      selectedHandler = _ref.selectedHandler,
	      span = _ref.span,
	      average = _ref.average,
	      index = _ref.index,
	      otherValue = _ref.otherValue,
	      currentValue = _ref.currentValue;
	
	  var color = selected ? '#404180' : '#6061A0';
	  var opacity = faded ? 0.6 : 1;
	  var percentDiff = 100 * Math.abs(value - average) / span;
	  var oPercentDiff = 100 * Math.abs(otherValue - average) / span;
	  var cPercentDiff = 100 * Math.abs(currentValue - average) / span;
	  var top = value > average ? 50 - percentDiff : 50 + percentDiff;
	  var oTop = otherValue > average ? 50 - oPercentDiff : 50 + oPercentDiff;
	  var cTop = currentValue > average ? 50 - cPercentDiff : 50 + cPercentDiff;
	  var lHeight = Math.abs(Math.max(cTop, oTop) - Math.min(cTop, oTop));
	  var lTop = Math.min(cTop, oTop);
	  var below = value < average ? true : false;
	  return _react2.default.createElement(
	    'div',
	    {
	      className: 'cmwf--performance-chart-state ' + (faded ? "faded" : "") + ' ' + (below ? "below" : ""),
	      onClick: function onClick() {
	        return selectedHandler(state);
	      },
	      role: 'button',
	      tabIndex: 0,
	      style: {
	        left: 100 / 51 * index + '%',
	        top: 100 / 51 * index + '%',
	        height: 100 / 51 + '%', // 100% / 51 (50 states + DC)
	        width: 100 / 51 + '%' // 100% / 51 (50 states + DC)
	      }
	    },
	    _react2.default.createElement('div', { className: 'cmwf--performance-chart-state-dot dot--baseline',
	      style: {
	        left: 100 - oTop + '%',
	        top: oTop + '%'
	      }
	    }),
	    _react2.default.createElement('div', { className: 'cmwf--performance-chart-state-dot dot--current',
	      style: {
	        left: 100 - cTop + '%',
	        top: cTop + '%'
	      }
	    }),
	    _react2.default.createElement('div', { className: 'cmwf--performance-chart-state-line',
	      style: {
	        height: lHeight + '%',
	        width: lHeight + '%',
	        left: 100 - lTop + '%',
	        top: lTop + '%'
	      }
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'cmwf--performance-chart-state-dot dot--main ' + (selected ? "selected" : ""),
	        style: {
	          // background: color,
	          // opacity,
	          left: 100 - top + '%',
	          top: top + '%'
	        }
	      },
	      _react2.default.createElement(
	        'span',
	        null,
	        state
	      )
	    )
	  );
	};
	
	DimensionChartState.propTypes = {
	  state: _propTypes2.default.string.isRequired,
	  value: _propTypes2.default.number.isRequired,
	  otherValue: _propTypes2.default.number.isRequired,
	  index: _propTypes2.default.number.isRequired,
	  faded: _propTypes2.default.bool.isRequired,
	  selected: _propTypes2.default.bool.isRequired,
	  selectedHandler: _propTypes2.default.func.isRequired,
	  span: _propTypes2.default.number.isRequired,
	  average: _propTypes2.default.number.isRequired
	};
	
	exports.default = DimensionChartState;
	module.exports = exports['default'];

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dimensionChartState = __webpack_require__(565);
	
	var _dimensionChartState2 = _interopRequireDefault(_dimensionChartState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DimensionChart = function DimensionChart(_ref) {
	  var data = _ref.data,
	      faded = _ref.faded,
	      selected = _ref.selected,
	      _selectedHandler = _ref.selectedHandler;
	
	  // summed up the current value.
	  var total = data.reduce(function (sum, state) {
	    return sum + state.currentValue;
	  }, 0);
	  // cloned the data array and sort in desc by other value.
	  var dataByOther = data.slice().sort(function (a, b) {
	    return b.otherValue - a.otherValue;
	  });
	  var average = total / data.length;
	  var highSpan = data[0].currentValue > dataByOther[0].otherValue ? data[0].currentValue - average : dataByOther[0].otherValue - average;
	  var lowSpan = data[data.length - 1] < dataByOther[dataByOther.length - 1].otherValue ? average - data[data.length - 1].currentValue : average - dataByOther[dataByOther.length - 1].otherValue;
	  var span = highSpan > lowSpan ? highSpan * 2 : lowSpan * 2;
	  var stateCharts = data.map(function (state, index) {
	    return _react2.default.createElement(_dimensionChartState2.default, _extends({}, state, {
	      selected: selected.includes(state.state),
	      faded: faded.includes(state.state),
	      selectedHandler: function selectedHandler(selectedState) {
	        if (selected.includes(selectedState)) {
	          selected.splice(selected.indexOf(selectedState), 1);
	          _selectedHandler(selected);
	        } else {
	          _selectedHandler([].concat(selected, [selectedState]));
	        }
	      },
	      span: span,
	      average: average,
	      index: index,
	      key: index
	    }));
	  });
	  return _react2.default.createElement(
	    'div',
	    { className: 'cmwf--performance-chart-data' },
	    _react2.default.createElement(
	      'div',
	      { className: 'cmwf--performance-chart-national-average' },
	      _react2.default.createElement(
	        'span',
	        { className: 'cmwf--performance-chart-label average' },
	        'U.S. Average'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'cmwf--performance-chart-legend' },
	      _react2.default.createElement(
	        'span',
	        { className: 'cmwf--performance-chart-label better' },
	        'Better',
	        _react2.default.createElement(
	          'span',
	          null,
	          ' Performance'
	        )
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'cmwf--performance-chart-label worse' },
	        'Worse',
	        _react2.default.createElement(
	          'span',
	          null,
	          ' Performance'
	        )
	      )
	    ),
	    stateCharts
	  );
	};
	
	DimensionChart.propTypes = {
	  data: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  faded: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
	  selected: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
	  selectedHandler: _propTypes2.default.func.isRequired
	};
	
	exports.default = DimensionChart;
	module.exports = exports['default'];

/***/ }),

/***/ 567:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DimensionToggle = function DimensionToggle(_ref) {
	  var selected = _ref.selected,
	      changeHandler = _ref.changeHandler;
	  return _react2.default.createElement(
	    'div',
	    { className: 'cmwf--dimension-select-group' },
	    _react2.default.createElement(
	      'label',
	      { htmlFor: 'cmwf--dimension-select' },
	      'Dimension'
	    ),
	    ' ',
	    _react2.default.createElement(
	      'select',
	      {
	        id: 'cmwf--dimension-select',
	        className: 'select__small',
	        onChange: function onChange(e) {
	          return changeHandler(e.target.value);
	        },
	        defaultValue: selected
	      },
	      _react2.default.createElement(
	        'option',
	        { value: 'OVERALL' },
	        'Overall Ranking'
	      ),
	      _react2.default.createElement(
	        'option',
	        { value: 'ACCESS' },
	        'Access and Affordability'
	      ),
	      _react2.default.createElement(
	        'option',
	        { value: 'QUALITY' },
	        'Prevention and Treatment'
	      ),
	      _react2.default.createElement(
	        'option',
	        { value: 'USE' },
	        'Avoidable Hospital Use and Cost'
	      ),
	      _react2.default.createElement(
	        'option',
	        { value: 'LIVES' },
	        'Healthy Lives'
	      ),
	      _react2.default.createElement(
	        'option',
	        { value: 'DISPARITY' },
	        'Income Disparity'
	      )
	    )
	  );
	};
	
	DimensionToggle.propTypes = {
	  selected: _propTypes2.default.string.isRequired,
	  changeHandler: _propTypes2.default.func.isRequired
	};
	
	exports.default = DimensionToggle;
	module.exports = exports['default'];

/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mapColors = __webpack_require__(186);
	
	var _mapColors2 = _interopRequireDefault(_mapColors);
	
	var _mapKeyColorStyle = __webpack_require__(407);
	
	var _mapKeyColorStyle2 = _interopRequireDefault(_mapKeyColorStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapNationalKey = function MapNationalKey() {
	  return _react2.default.createElement(
	    'ul',
	    { className: 'cmwf--map-key cmwf--map-key-national' },
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement('div', { style: { backgroundColor: _mapColors2.default[1] } }),
	      ' ',
	      'Top state nationally'
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement('div', { style: { backgroundColor: _mapColors2.default[2] } }),
	      ' ',
	      'Better-than-average states'
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement('div', { style: { backgroundColor: _mapColors2.default[3] } }),
	      ' ',
	      'Worse-than-average states'
	    )
	  );
	};
	
	exports.default = MapNationalKey;
	module.exports = exports['default'];

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mapColors = __webpack_require__(186);
	
	var _mapColors2 = _interopRequireDefault(_mapColors);
	
	var _mapKeyColorStyle = __webpack_require__(407);
	
	var _mapKeyColorStyle2 = _interopRequireDefault(_mapKeyColorStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapRegionalKey = function MapRegionalKey() {
	  return _react2.default.createElement(
	    'ul',
	    { className: 'cmwf--map-key cmwf--map-key-regional' },
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement('div', { style: { backgroundColor: _mapColors2.default[1] } }),
	      ' ',
	      'Top state in region'
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement('div', { style: { backgroundColor: _mapColors2.default[2] } }),
	      ' ',
	      'Better-than-average states in region'
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement('div', { style: { backgroundColor: _mapColors2.default[3] } }),
	      ' ',
	      'Worse-than-average states in region'
	    )
	  );
	};
	
	exports.default = MapRegionalKey;
	module.exports = exports['default'];

/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegionToggle = function RegionToggle(_ref) {
	  var selected = _ref.selected,
	      changeHandler = _ref.changeHandler;
	
	
	  var region = __webpack_require__(357);
	
	  var regionOptions = Object.keys(region).sort().map(function (value) {
	    return _react2.default.createElement(
	      'option',
	      { key: value, value: value },
	      value
	    );
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cmwf--region-select--group' },
	    _react2.default.createElement(
	      'label',
	      { htmlFor: 'cmwf--region-select' },
	      'Region'
	    ),
	    ' ',
	    _react2.default.createElement(
	      'select',
	      {
	        id: 'cmwf--region-select',
	        className: 'select__small',
	        onChange: function onChange(e) {
	          return changeHandler(e.target.value);
	        },
	        defaultValue: selected
	      },
	      _react2.default.createElement(
	        'option',
	        { value: '' },
	        '-- All Regions --'
	      ),
	      regionOptions
	    )
	  );
	};
	
	RegionToggle.propTypes = {
	  selected: _propTypes2.default.string.isRequired,
	  changeHandler: _propTypes2.default.func.isRequired
	};
	
	exports.default = RegionToggle;
	module.exports = exports['default'];

/***/ }),

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactUsaMap = __webpack_require__(1366);
	
	var _reactUsaMap2 = _interopRequireDefault(_reactUsaMap);
	
	var _loading = __webpack_require__(67);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _mapColors = __webpack_require__(186);
	
	var _mapColors2 = _interopRequireDefault(_mapColors);
	
	var _mapNationalKey = __webpack_require__(568);
	
	var _mapNationalKey2 = _interopRequireDefault(_mapNationalKey);
	
	var _mapRegionalKey = __webpack_require__(569);
	
	var _mapRegionalKey2 = _interopRequireDefault(_mapRegionalKey);
	
	var _request = __webpack_require__(68);
	
	var _request2 = _interopRequireDefault(_request);
	
	var _statesToArray = __webpack_require__(139);
	
	var _statesToArray2 = _interopRequireDefault(_statesToArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var regions = __webpack_require__(357);
	
	var sortByOverall = function sortByOverall(a, b) {
	  return parseFloat(b[1].OVERALL) - parseFloat(a[1].OVERALL);
	};
	
	var totalOverall = function totalOverall(states) {
	  return states.reduce(function (value, current) {
	    return value + current.overall;
	  }, 0);
	};
	
	var averageOveral = function averageOveral(states) {
	  return totalOverall(states) / states.length;
	};
	
	var regionByOverall = function regionByOverall(region, dimensions) {
	  return (0, _statesToArray2.default)(dimensions).filter(function (item) {
	    return regions[region].includes(item.state);
	  }).sort(sortByOverall).map(function (item, index) {
	    return _extends({}, item, {
	      overall: parseFloat(item[1].OVERALL),
	      regionIndex: index
	    });
	  });
	};
	
	var stateSectionNational = function stateSectionNational(state, dimensions) {
	  var values = (0, _statesToArray2.default)(dimensions).sort(sortByOverall).map(function (item, index) {
	    return _extends({}, item, {
	      overall: parseFloat(item[1].OVERALL),
	      index: index
	    });
	  });
	  var stateInList = values.filter(function (item) {
	    return item.state === state;
	  })[0];
	  console.log(stateInList);
	  console.log(totalOverall(values));
	  console.log(averageOveral(values));
	  if (stateInList.index < 1) {
	    return 1;
	  }
	  if (stateInList.overall >= averageOveral(values)) {
	    return 2;
	  }
	  return 3;
	};
	
	var stateSectionRegional = function stateSectionRegional(state, region, dimensions) {
	  var values = regionByOverall(region, dimensions);
	  var stateInRegion = values.filter(function (item) {
	    return item.state === state;
	  })[0];
	  if (stateInRegion.regionIndex < 1) {
	    return 1;
	  }
	  if (stateInRegion.overall >= averageOveral(values)) {
	    return 2;
	  }
	  return 3;
	};
	
	var Map = function (_React$Component) {
	  _inherits(Map, _React$Component);
	
	  function Map(props) {
	    _classCallCheck(this, Map);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      data: {},
	      region: ''
	    };
	    _this.onStateClick = _this.onStateClick.bind(_this);
	    return _this;
	  }
	
	  Map.prototype.componentWillMount = function componentWillMount() {
	    var data = this.state.data;
	    /* istanbul ignore next */
	
	    if (!data.dimensions) {
	      this.loadJSON('dimensions');
	    }
	  };
	
	  Map.prototype.onStateClick = function onStateClick(state) {
	    var region = this.state.region;
	
	    var clickedRegions = Object.keys(regions).filter(function (clickRegion) {
	      return regions[clickRegion].includes(state);
	    });
	    if (clickedRegions.length === 0 || clickedRegions[0] == region) {
	      this.setState({ region: '' });
	    } else {
	      this.setState({ region: clickedRegions[0] });
	    }
	  };
	
	  Map.prototype.statesCustomConfig = function statesCustomConfig() {
	    var _state = this.state,
	        data = _state.data,
	        region = _state.region;
	    var dimensions = data.dimensions;
	
	    return Object.keys(dimensions).reduce(function (config, state) {
	      var _extends2;
	
	      var stateColor = '#D8D8D8';
	      if (region === '') {
	        stateColor = _mapColors2.default[stateSectionNational(state, dimensions)];
	      } else if (regions[region].includes(state)) {
	        stateColor = _mapColors2.default[stateSectionRegional(state, region, dimensions)];
	      }
	      if (state === 'DC') {
	        return _extends({}, config, {
	          DC1: {
	            fill: stateColor
	          },
	          DC2: {
	            fill: stateColor
	          }
	        });
	      }
	      return _extends({}, config, (_extends2 = {}, _extends2[state] = {
	        fill: stateColor
	      }, _extends2));
	    }, {});
	  };
	
	  Map.prototype.loadJSON = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(name) {
	      var newData;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return (0, _request2.default)('/data/' + name + '.json');
	
	            case 2:
	              newData = _context.sent;
	
	              this.setState(function (prevState) {
	                var _extends3;
	
	                return {
	                  data: _extends({}, prevState.data, (_extends3 = {}, _extends3[name] = newData, _extends3))
	                };
	              });
	
	            case 4:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    function loadJSON(_x) {
	      return _ref.apply(this, arguments);
	    }
	
	    return loadJSON;
	  }();
	
	  Map.prototype.render = function render() {
	    var _this2 = this;
	
	    var data = this.state.data;
	
	    if (!data.dimensions) {
	      return _react2.default.createElement(_loading2.default, { message: 'Loading data...' });
	    }
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactUsaMap2.default, {
	        title: '',
	        customize: this.statesCustomConfig(),
	        onClick: function onClick(e) {
	          return _this2.onStateClick(e.target.dataset.name);
	        }
	      }),
	      this.state.region === '' ? _react2.default.createElement(_mapNationalKey2.default, null) : _react2.default.createElement(_mapRegionalKey2.default, null)
	    );
	  };
	
	  return Map;
	}(_react2.default.Component);
	
	exports.default = Map;
	module.exports = exports['default'];

/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baselineToggle = __webpack_require__(564);
	
	var _baselineToggle2 = _interopRequireDefault(_baselineToggle);
	
	var _dimensionChart = __webpack_require__(566);
	
	var _dimensionChart2 = _interopRequireDefault(_dimensionChart);
	
	var _dimensionToggle = __webpack_require__(567);
	
	var _dimensionToggle2 = _interopRequireDefault(_dimensionToggle);
	
	var _loading = __webpack_require__(67);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _regionToggle = __webpack_require__(570);
	
	var _regionToggle2 = _interopRequireDefault(_regionToggle);
	
	var _request = __webpack_require__(68);
	
	var _request2 = _interopRequireDefault(_request);
	
	var _states = __webpack_require__(59);
	
	var _states2 = _interopRequireDefault(_states);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var regions = __webpack_require__(357);
	
	var Performance = function (_React$Component) {
	  _inherits(Performance, _React$Component);
	
	  function Performance(props) {
	    _classCallCheck(this, Performance);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      baseline: false,
	      data: {},
	      dimension: 'OVERALL',
	      region: '',
	      selected: []
	    };
	    _this.onBaselineChange = _this.onBaselineChange.bind(_this);
	    _this.onRegionChange = _this.onRegionChange.bind(_this);
	    _this.onDimensionChange = _this.onDimensionChange.bind(_this);
	    _this.onSelectedChange = _this.onSelectedChange.bind(_this);
	    return _this;
	  }
	
	  Performance.prototype.componentWillMount = function componentWillMount() {
	    var data = this.state.data;
	    /* istanbul ignore next */
	
	    if (!data.dimensions) {
	      this.loadJSON('dimensions2');
	    }
	  };
	
	  Performance.prototype.onBaselineChange = function onBaselineChange(baseline) {
	    this.setState({ baseline: baseline });
	  };
	
	  Performance.prototype.onRegionChange = function onRegionChange(region) {
	    this.setState({ region: region });
	  };
	
	  Performance.prototype.onDimensionChange = function onDimensionChange(dimension) {
	    this.setState({ dimension: dimension });
	  };
	
	  Performance.prototype.onSelectedChange = function onSelectedChange(selected) {
	    this.setState({ selected: selected });
	  };
	
	  Performance.prototype.loadJSON = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(name) {
	      var newData;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return (0, _request2.default)('/data/' + name + '.json');
	
	            case 2:
	              newData = _context.sent;
	
	              this.setState(function (prevState) {
	                var _extends2;
	
	                return {
	                  data: _extends({}, prevState.data, (_extends2 = {}, _extends2['dimensions'] = newData, _extends2))
	                };
	              });
	
	            case 4:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    function loadJSON(_x) {
	      return _ref.apply(this, arguments);
	    }
	
	    return loadJSON;
	  }();
	
	  Performance.prototype.chartData = function chartData() {
	    var _state = this.state,
	        data = _state.data,
	        dimension = _state.dimension,
	        baseline = _state.baseline;
	
	    return Object.keys(data.dimensions).map(function (state) {
	      return {
	        state: state,
	        value: parseFloat(data.dimensions[state][baseline ? 0 : 1][dimension]),
	        otherValue: parseFloat(data.dimensions[state][0][dimension]),
	        currentValue: parseFloat(data.dimensions[state][1][dimension])
	      };
	    }).sort(function (a, b) {
	      var aCurrent = parseFloat(data.dimensions[a.state][1][dimension]);
	      var bCurrent = parseFloat(data.dimensions[b.state][1][dimension]);
	      return bCurrent - aCurrent;
	    });
	  };
	
	  Performance.prototype.faded = function faded() {
	    var region = this.state.region;
	
	    if (region === '') {
	      return [];
	    }
	
	    return Object.keys(_states2.default).filter(function (state) {
	      return !regions[region].includes(state);
	    });
	  };
	
	  Performance.prototype.render = function render() {
	    var data = this.state.data;
	
	    if (!data.dimensions) {
	      return _react2.default.createElement(_loading2.default, { message: 'Loading data...' });
	    }
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'cmwf--performance-select-groups' },
	        _react2.default.createElement(_baselineToggle2.default, {
	          selected: this.state.baseline,
	          changeHandler: this.onBaselineChange
	        }),
	        _react2.default.createElement(_regionToggle2.default, {
	          selected: this.state.region,
	          changeHandler: this.onRegionChange
	        }),
	        _react2.default.createElement(_dimensionToggle2.default, {
	          selected: this.state.dimension,
	          changeHandler: this.onDimensionChange
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'cmwf--performance-chart-wrapper' },
	        _react2.default.createElement(_dimensionChart2.default, {
	          data: this.chartData(),
	          faded: this.faded(),
	          selected: this.state.selected,
	          selectedHandler: this.onSelectedChange
	        })
	      )
	    );
	  };
	
	  return Performance;
	}(_react2.default.Component);
	
	exports.default = Performance;
	module.exports = exports['default'];

/***/ }),

/***/ 186:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var mapColors = {
	  1: '#50BDBB',
	  2: '#B9E5E5',
	  3: '#585C66'
	};
	
	exports.default = mapColors;
	module.exports = exports['default'];

/***/ }),

/***/ 407:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var mapKeyColorStyle = {
	  // width: '1em',
	  // height: '1em',
	  // borderRadius: '0.5em',
	  // display: 'inline-block',
	};
	
	exports.default = mapKeyColorStyle;
	module.exports = exports["default"];

/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(140);
	
	var _map = __webpack_require__(574);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _performance = __webpack_require__(575);
	
	var _performance2 = _interopRequireDefault(_performance);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ShareExhibit = __webpack_require__(92);
	
	var _ShareExhibit2 = _interopRequireDefault(_ShareExhibit);
	
	var _caseStudyNewYork = __webpack_require__(189);
	
	var _caseStudyNewYork2 = _interopRequireDefault(_caseStudyNewYork);
	
	var _caseStudyTwoStates = __webpack_require__(190);
	
	var _caseStudyTwoStates2 = _interopRequireDefault(_caseStudyTwoStates);
	
	var _caseStudyHospitalMortality = __webpack_require__(188);
	
	var _caseStudyHospitalMortality2 = _interopRequireDefault(_caseStudyHospitalMortality);
	
	var _scorecard_rankings = __webpack_require__(1403);
	
	var _scorecard_rankings2 = _interopRequireDefault(_scorecard_rankings);
	
	var _exhibitOverall = __webpack_require__(1396);
	
	var _exhibitOverall2 = _interopRequireDefault(_exhibitOverall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Rankings = function Rankings(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'section highlights_header section__heavy' },
	        _react2.default.createElement(
	          'figure',
	          { className: 'highlights_header__image' },
	          _react2.default.createElement('img', { src: _scorecard_rankings2.default, alt: '' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'highlights_header__content' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'title__page' },
	            'State Rankings'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Hawaii, Massachusetts, Minnesota, Iowa, and Connecticut are the top-ranked states according to the ',
	            _react2.default.createElement(
	              'em',
	              null,
	              '2020 Scorecard'
	            ),
	            ', which assesses all 50 states and the District of Columbia on more than 45 measures of access to health care, quality of care, service use and costs of care, health outcomes, and income-based health care disparities.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section section__centered section__narrow' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__content' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Which states moved up the most in the rankings between 2014 and 2018, and which states dropped?'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'The District of Columbia had the largest jump in rankings, up 13 spots. New York gained 10 spots in the rankings and New Jersey rose nine spots.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'South Dakota fell 19 spots in the rankings, while Wyoming and Maine fell 12 and 17 spots, respectively.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section l-full' },
	        _react2.default.createElement(
	          'div',
	          { id: 'exhibit-14', className: 'section__row' },
	          _react2.default.createElement(
	            'div',
	            { id: 'overall-health-system-performance', className: 'section__content section__exhibit section__exhibit__padded section__exhibit__interactive' },
	            _react2.default.createElement(
	              'figure',
	              null,
	              _react2.default.createElement(
	                'h2',
	                { className: 'title__block' },
	                'Overall health system performance (prior to COVID-19)'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'instructions' },
	                _react2.default.createElement(
	                  'ul',
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Adjust the options to see how states performed when compared to the baseline, against other states in their region, and in different dimensions.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Highlight a state by selecting its circle'
	                  )
	                )
	              ),
	              _react2.default.createElement(_performance2.default, null),
	              _react2.default.createElement(
	                'figcaption',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  { className: 'performance__large' },
	                  'Note: States are arranged in rank order from left (best) to right (worst), based on their overall 2020 Scorecard rank. The 2020 Scorecard rank reflects data generally from 2018, prior to the COVID-19 pandemic.'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'performance__small' },
	                  'States are arranged in rank order from top (best) to bottom (worst), based on their ',
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    '2020 Scorecard'
	                  ),
	                  ' rank.'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('hr', { className: 'section__divider' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section section__centered' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'section__title' },
	          'What are the leading states by region?'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'list__4-up' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Great Lakes'
	                ),
	                _react2.default.createElement('br', null),
	                ' Wisconsin'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Mid-Atlantic'
	                ),
	                _react2.default.createElement('br', null),
	                ' New York'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'New England'
	                ),
	                _react2.default.createElement('br', null),
	                ' Massachusetts'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Plains'
	                ),
	                _react2.default.createElement('br', null),
	                ' Minnesota'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Rocky Mountain'
	                ),
	                _react2.default.createElement('br', null),
	                ' Colorado'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Southeast'
	                ),
	                _react2.default.createElement('br', null),
	                ' Virginia'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Southwest'
	                ),
	                _react2.default.createElement('br', null),
	                ' New Mexico'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'West'
	                ),
	                _react2.default.createElement('br', null),
	                ' Hawaii'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section l-full' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row' },
	          _react2.default.createElement(
	            'div',
	            { id: 'exhibit-16', className: 'section__content section__exhibit section__exhibit__interactive section__exhibit__padded' },
	            _react2.default.createElement(
	              'figure',
	              null,
	              _react2.default.createElement(
	                'h2',
	                { className: 'title__block' },
	                'State health system performance varies within regions'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'instructions' },
	                _react2.default.createElement(
	                  'ul',
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Select a state to highlight a region of the country.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Choose a selected state to return to the national view.'
	                  )
	                )
	              ),
	              _react2.default.createElement(_map2.default, null),
	              _react2.default.createElement(
	                'figcaption',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Note: Regions are U.S. Census regions. Regional shading is based on performance among states within the region only. See Scorecard Methods for additional detail.'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('hr', { className: 'section__divider' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section section__centered section__narrow' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__content' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Which states improved on the most indicators?'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Florida, Kentucky, Louisiana, and Virginia each improved on 17 of 43 indicators we track over time, although Louisiana had a larger net gain, having gotten worse on fewer indicators (seven indicators) than Florida and Virginia (12 indicators). Five states (Arizona, Arkansas, Mississippi, Missouri, and West Virginia) each improved on 16 indicators.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Fourteen states got worse on more indicators than they improved on.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section section__full' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row' },
	          _react2.default.createElement(
	            'div',
	            { id: 'exhibit-15', className: 'section__content section__exhibit section__exhibit__padded' },
	            _react2.default.createElement(
	              'figure',
	              null,
	              _react2.default.createElement(
	                'h2',
	                { className: 'title__block' },
	                'More improvement than decline: Florida, Kentucky, Louisiana, and Virginia improved most, with gains on 17 indicators between 2014 and 2018, prior to COVID-19 '
	              ),
	              _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/img/exhibits/exhibit-15-web.png'), alt: '' }),
	              _react2.default.createElement(
	                'figcaption',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Notes: Based on five-year trends for 43 of 49 total indicators (disparity dimension not included), generally reflecting 2014 to 2018, prior to COVID-19 pandemic; trend data are not available for all indicators. Bar length equals the total number of indicators with any improvement or worsening with an absolute value greater than 0.5 standard deviations (StDev) of the state distribution.'
	                )
	              )
	            ),
	            _react2.default.createElement(_ShareExhibit2.default, {
	              exhibit: 'exhibit-15',
	              site: data.site.siteMetadata,
	              social: data.allSocialJson.edges })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Rankings;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 357:
/***/ (function(module, exports) {

	module.exports = {"Southeast":["AL","AR","FL","GA","KY","LA","MS","NC","SC","TN","VA","WV"],"West":["AK","CA","HI","NV","OR","WA"],"Southwest":["AZ","NM","OK","TX"],"Rocky Mountain":["CO","ID","MT","UT","WY"],"New England":["CT","ME","MA","NH","RI","VT"],"Mid-Atlantic":["DE","DC","MD","NJ","NY","PA"],"Great Lakes":["IL","IN","MI","OH","WI"],"Plains":["IA","KS","MN","MO","NE","ND","SD"]}

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-rankings-js-5a9f2aee7a71e2c27c05.js